const ResourcesIds = {
  WELCOME_USER: "welcome_user",
  LOGIN: "login",
  DASHBOARD_SUBTITLE: "dashboard_subtitle",
  QUICK_ACTIONS: "quick_actions",
  UPCOMING_TITLE: "upcoming_title",
  VIEW_ALL_BUTTON: "view_all_button",
  EMPTY_STATE_TITLE: "empty_state_title",
  EMPTY_STATE_SUBTITLE: "empty_state_subtitle",
  DASHBOARD_ACTIVE_PLANS_TITLE: "dashboard_active_plans_title",
  DASHBOARD_ACTIVE_PLANS_EMPTY_TITLE: "dashboard_active_plans_empty_title",
  DASHBOARD_ACTIVE_PLANS_EMPTY_SUBTITLE:
    "dashboard_active_plans_empty_subtitle",
  MY_APPOINTMENTS_SUBTITLE: "my_appointments_subtitle",
  BOOK_APPOINTMENT_BUTTON: "book_appointment_button",
  CANCEL_TEXT: "cancel_text",
  LOADING_TEXT: "loading_text",
  BACK_BUTTON: "back_button",
  CONTINUE_BUTTON: "continue_button",
  LOGIN_TITLE: "login_title",
  LOGIN_SUBTITLE: "login_subtitle",
  EMAIL_LABEL: "email_label",
  PASSWORD_LABEL: "password_label",
  SIGN_IN_BUTTON: "sign_in_button",
  SIGNING_IN_TEXT: "signing_in_text",
  CLINIC_LABEL: "clinic_label",
  CHOOSE_CLINIC_PROMPT: "choose_clinic_prompt",
  FORGOT_PASSWORD_TEXT: "forgot_password_text",
  REGISTER_PROMPT: "register_prompt",
  REGISTER_LINK_TEXT: "register_link_text",
  EMAIL_REQUIRED: "email_required",
  PASSWORD_REQUIRED: "password_required",
  REGISTER_TITLE: "register_title",
  REGISTER_SUBTITLE: "register_subtitle",
  CONFIRM_PASSWORD_LABEL: "confirm_password_label",
  FIRST_NAME_LABEL: "first_name_label",
  LAST_NAME_LABEL: "last_name_label",
  CREATE_ACCOUNT_BUTTON: "create_account_button",
  CREATING_ACCOUNT_TEXT: "creating_account_text",
  LOGIN_PROMPT: "login_prompt",
  LOGIN_LINK_TEXT: "login_link_text",
  ENTER_VALID_EMAIL: "enter_valid_email",
  PASSWORDS_DONT_MATCH: "passwords_dont_match",
  FIRST_NAME_REQUIRED: "first_name_required",
  LAST_NAME_REQUIRED: "last_name_required",
  FIRST_NAME_VALIDATION_ERROR: "first_name_validation_error",
  LAST_NAME_VALIDATION_ERROR: "last_name_validation_error",
  TERMS_AND_CONDITIONS_REQUIRED: "terms_and_conditions_required",
  TERMS_AND_CONDITIONS_PREFIX: "terms_and_conditions_prefix",
  TERMS_AND_CONDITIONS: "terms_and_conditions",
  WELCOME_TO_APP: "welcome_to_app",
  CONFIRMATION_EMAIL_SENT: "confirmation_email_sent",
  GO_TO_LOGIN: "go_to_login",
  EMAIL_SENT_TITLE: "email_sent_title",
  PASSWORD_RESET_EMAIL_INFO: "password_reset_email_info",
  PASSWORD_RESET_INSTRUCTIONS: "password_reset_instructions",
  FORGOT_PASSWORD_TITLE: "forgot_password_title",
  FORGOT_PASSWORD_SUBTITLE: "forgot_password_subtitle",
  FORGOT_PASSWORD_HINT: "forgot_password_hint",
  FORGOT_PASSWORD_ERROR: "forgot_password_error",
  CHANGE_PASSWORD_TITLE: "change_password_title",
  CHANGE_PASSWORD_SUBTITLE: "change_password_subtitle",
  CHANGE_PASSWORD_SUBMIT: "change_password_submit",
  CHANGE_PASSWORD_SUCCESS_TITLE: "change_password_success_title",
  CHANGE_PASSWORD_SUCCESS_SUBTITLE: "change_password_success_subtitle",
  CHANGE_PASSWORD_ERROR: "change_password_error",
  REGISTER_ERROR: "register_error",
  LOGIN_FAILED_DEFAULT: "login_failed_default",
  SESSION_ENDED_NOTICE: "session_ended_notice",
  RESETTING_PASSWORD: "resetting_password",
  SUBMIT: "submit",
  DASHBOARD: "dashboard",
  BOOK_APPOINTMENT: "book_appointment",
  MY_APPOINTMENTS: "my_appointments",
  ABOUT: "about",
  WELCOME: "welcome",
  PROFILE: "profile",
  LOGOUT: "logout",
  REGISTER: "register",
  HERO_HEADLINE_LINE1: "hero_headline_line1",
  HERO_HEADLINE_LINE2: "hero_headline_line2",
  HERO_SUBTITLE: "hero_subtitle",
  FEATURES_HEADING: "features_heading",
  FEATURES_SUBHEADING: "features_subheading",
  FEATURE_CERTIFIED_EXPERTS_TITLE: "feature_certified_experts_title",
  FEATURE_CERTIFIED_EXPERTS_DESC: "feature_certified_experts_desc",
  FEATURE_FLEXIBLE_SCHEDULING_TITLE: "feature_flexible_scheduling_title",
  FEATURE_FLEXIBLE_SCHEDULING_DESC: "feature_flexible_scheduling_desc",
  FEATURE_PERSONALIZED_CARE_TITLE: "feature_personalized_care_title",
  FEATURE_PERSONALIZED_CARE_DESC: "feature_personalized_care_desc",
  FEATURE_SECURE_PRIVATE_TITLE: "feature_secure_private_title",
  FEATURE_SECURE_PRIVATE_DESC: "feature_secure_private_desc",
  CTA_TITLE: "cta_title",
  CTA_SUBTITLE: "cta_subtitle",
  LEARN_MORE: "learn_more",
  PROFILE_SETTINGS_TITLE: "profile_settings_title",
  PROFILE_SETTINGS_SUBTITLE: "profile_settings_subtitle",
  PERSONAL_INFORMATION: "personal_information",
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  SAVE_CHANGES: "save_changes",
  SAVING: "saving",
  USERNAME_LABEL: "username_label",
  MEMBER_SINCE: "member_since",
  PROFILE_UPDATE_SUCCESS: "profile_update_success",
  PROFILE_UPDATE_ERROR_DEFAULT: "profile_update_error_default",
  SERVICES_TITLE: "services_title",
  QUICK_ACTION_BOOK_NEW_APPOINTMENT_TITLE:
    "quick_action_book_new_appointment_title",
  QUICK_ACTION_BOOK_NEW_APPOINTMENT_DESC:
    "quick_action_book_new_appointment_desc",
  QUICK_ACTION_VIEW_ALL_APPOINTMENTS_TITLE:
    "quick_action_view_all_appointments_title",
  QUICK_ACTION_VIEW_ALL_APPOINTMENTS_DESC:
    "quick_action_view_all_appointments_desc",
  OUR_SERVICES_TITLE: "our_services_title",
  OUR_SERVICES_SUBTITLE: "our_services_subtitle",
  NO_SERVICES_TITLE: "no_services_title",
  NO_SERVICES_SUBTITLE: "no_services_subtitle",
  NO_SERVICES_ADMIN_SUBTITLE: "no_services_admin_subtitle",
  SERVICES_LOAD_ERROR: "services_load_error",
  SERVICES_EDIT_ACTION: "services_edit_action",
  SERVICES_SAVE_ACTION: "services_save_action",
  SERVICES_SAVE_SUCCESS: "services_save_success",
  SERVICES_SAVE_ERROR: "services_save_error",
  THERAPIST_SERVICES_ACTION: "therapist_services_action",
  THERAPIST_SERVICES_TITLE: "therapist_services_title",
  THERAPIST_SERVICES_DESCRIPTION: "therapist_services_description",
  THERAPIST_SERVICES_NO_CATALOG: "therapist_services_no_catalog",
  THERAPIST_SERVICES_SUCCESS: "therapist_services_success",
  THERAPIST_SERVICES_ERROR: "therapist_services_error",
  SERVICES_DISCARD_TITLE: "services_discard_title",
  SERVICES_DISCARD_DESCRIPTION: "services_discard_description",
  SERVICES_DISCARD_CONFIRM: "services_discard_confirm",
  SERVICES_FIELD_RO: "services_field_ro",
  SERVICES_FIELD_EN: "services_field_en",
  SERVICES_FIELD_PRICE: "services_field_price",
  SERVICES_FIELD_PRICE_TOTAL: "services_field_price_total",
  SERVICES_FIELD_MINUTES: "services_field_minutes",
  SERVICES_FIELD_SESSIONS: "services_field_sessions",
  SERVICES_KIND_SESSION: "services_kind_session",
  SERVICES_KIND_PLAN: "services_kind_plan",
  SERVICES_FIELD_BASED_ON: "services_field_based_on",
  SERVICES_DIRECTION_LABEL: "services_direction_label",
  SERVICES_SECTION_LABEL: "services_section_label",
  SERVICES_TYPE_LABEL: "services_type_label",
  SERVICES_OPTION_LABEL: "services_option_label",
  SERVICES_ADD_DIRECTION: "services_add_direction",
  SERVICES_ADD_SECTION: "services_add_section",
  SERVICES_ADD_TYPE: "services_add_type",
  SERVICES_ADD_OPTION: "services_add_option",
  SERVICES_MOVE_UP: "services_move_up",
  SERVICES_MOVE_DOWN: "services_move_down",
  SERVICES_DELETE_DIRECTION: "services_delete_direction",
  SERVICES_DELETE_SECTION: "services_delete_section",
  SERVICES_DELETE_TYPE: "services_delete_type",
  SERVICES_DELETE_OPTION: "services_delete_option",
  SERVICES_DELETE_TITLE: "services_delete_title",
  SERVICES_DELETE_DESCRIPTION: "services_delete_description",
  SERVICES_REQUIRED_ERROR: "services_required_error",
  SERVICES_PRICE_ERROR: "services_price_error",
  SERVICES_COUNT_ERROR: "services_count_error",
  SERVICES_BASED_ON_ERROR: "services_based_on_error",
  SERVICES_BASED_ON_HINT: "services_based_on_hint",
  SERVICES_EMPTY_EDITOR: "services_empty_editor",
  SERVICES_BLOCKED_SAVE: "services_blocked_save",
  HERO_EYEBROW: "hero_eyebrow",
  FEATURES_EYEBROW: "features_eyebrow",
  CLINICS: "clinics",
  CLINICS_TITLE: "clinics_title",
  CLINICS_SUBTITLE: "clinics_subtitle",
  CLINICS_EMPTY_TITLE: "clinics_empty_title",
  CLINICS_EMPTY_SUBTITLE: "clinics_empty_subtitle",
  CLINICS_LOAD_ERROR: "clinics_load_error",
  ADD_CLINIC_BUTTON: "add_clinic_button",
  CLINIC_DISPLAY_NAME_LABEL: "clinic_display_name_label",
  CLINIC_SLUG_LABEL: "clinic_slug_label",
  CLINIC_WORKING_HOURS_LABEL: "clinic_working_hours_label",
  CLINIC_STATUS_LABEL: "clinic_status_label",
  CLINIC_ACTIONS_LABEL: "clinic_actions_label",
  CLINIC_STATUS_ACTIVE: "clinic_status_active",
  CLINIC_STATUS_INACTIVE: "clinic_status_inactive",
  CREATE_CLINIC_TITLE: "create_clinic_title",
  EDIT_CLINIC_TITLE: "edit_clinic_title",
  CLINIC_SLUG_HELPER: "clinic_slug_helper",
  CLINIC_SLUG_IMMUTABLE_HELPER: "clinic_slug_immutable_helper",
  CLINIC_DOMAIN_LABEL: "clinic_domain_label",
  CLINIC_DOMAIN_HELPER: "clinic_domain_helper",
  CLINIC_SENDER_EMAIL_LABEL: "clinic_sender_email_label",
  CLINIC_SENDER_EMAIL_HINT: "clinic_sender_email_hint",
  CLINIC_DOMAIN_INVALID: "clinic_domain_invalid",
  CLINIC_DOMAIN_NONE: "clinic_domain_none",
  CLINIC_DOMAIN_MORE_SUFFIX: "clinic_domain_more_suffix",
  CLINIC_DOMAINS_TITLE: "clinic_domains_title",
  CLINIC_DOMAINS_HINT: "clinic_domains_hint",
  CLINIC_DOMAINS_EMPTY: "clinic_domains_empty",
  CLINIC_DOMAIN_ADD_ACTION: "clinic_domain_add_action",
  CLINIC_DOMAIN_REMOVE_ACTION: "clinic_domain_remove_action",
  CLINIC_DOMAIN_MAKE_PRIMARY_ACTION: "clinic_domain_make_primary_action",
  CLINIC_DOMAIN_PRIMARY_CHIP: "clinic_domain_primary_chip",
  CLINIC_DOMAIN_ERROR: "clinic_domain_error",
  CLINIC_WORKING_HOURS_START_LABEL: "clinic_working_hours_start_label",
  CLINIC_WORKING_HOURS_END_LABEL: "clinic_working_hours_end_label",
  EDIT_TEXT: "edit_text",
  CLINIC_DISPLAY_NAME_REQUIRED: "clinic_display_name_required",
  CLINIC_SLUG_REQUIRED: "clinic_slug_required",
  CLINIC_SLUG_INVALID: "clinic_slug_invalid",
  CLINIC_FIELD_TOO_LONG: "clinic_field_too_long",
  CLINIC_WORKING_HOURS_INVALID: "clinic_working_hours_invalid",
  CLINIC_WORKING_HOURS_ORDER_ERROR: "clinic_working_hours_order_error",
  DEACTIVATE_CLINIC_ACTION: "deactivate_clinic_action",
  REACTIVATE_CLINIC_ACTION: "reactivate_clinic_action",
  DEACTIVATE_CLINIC_TITLE: "deactivate_clinic_title",
  DEACTIVATE_CLINIC_DESCRIPTION: "deactivate_clinic_description",
  DEACTIVATE_CLINIC_CONFIRM: "deactivate_clinic_confirm",
  REACTIVATE_CLINIC_TITLE: "reactivate_clinic_title",
  REACTIVATE_CLINIC_DESCRIPTION: "reactivate_clinic_description",
  REACTIVATE_CLINIC_CONFIRM: "reactivate_clinic_confirm",
  CLINIC_CREATED_SUCCESS: "clinic_created_success",
  CLINIC_UPDATED_SUCCESS: "clinic_updated_success",
  CLINIC_DEACTIVATED_SUCCESS: "clinic_deactivated_success",
  CLINIC_REACTIVATED_SUCCESS: "clinic_reactivated_success",
  CLINIC_SAVE_ERROR: "clinic_save_error",
  CLINIC_STATUS_CHANGE_ERROR: "clinic_status_change_error",
  ERROR_FORBIDDEN: "error_forbidden",
  ERROR_NETWORK: "error_network",
  CLINIC_MEMBERS_ACTION: "clinic_members_action",
  CLINIC_MEMBERS_TITLE: "clinic_members_title",
  CLINIC_MEMBERS_SUBTITLE: "clinic_members_subtitle",
  CLINIC_MEMBERS_EMPTY: "clinic_members_empty",
  CLINIC_MEMBERS_LOAD_ERROR: "clinic_members_load_error",
  MEMBER_NAME_LABEL: "member_name_label",
  MEMBER_ROLE_LABEL: "member_role_label",
  MEMBER_STATUS_LABEL: "member_status_label",
  MEMBER_STATUS_ACTIVE: "member_status_active",
  MEMBER_STATUS_PENDING: "member_status_pending",
  MEMBER_STATUS_EXPIRED: "member_status_expired",
  MEMBER_STATUS_RESEND_LABEL: "member_status_resend_label",
  MEMBER_STATUS_REVOKED: "member_status_revoked",
  ROLE_SUPER_ADMIN: "role_super_admin",
  ROLE_ADMIN: "role_admin",
  ROLE_THERAPIST: "role_therapist",
  ROLE_CUSTOMER: "role_customer",
  INVITE_ADMIN_ACTION: "invite_admin_action",
  INVITE_ADMIN_TITLE: "invite_admin_title",
  INVITE_ADMIN_DESCRIPTION: "invite_admin_description",
  INVITE_ADMIN_SUBMIT: "invite_admin_submit",
  INVITE_ADMIN_SUCCESS: "invite_admin_success",
  INVITE_ADMIN_ERROR: "invite_admin_error",
  INVITATION_LOADING: "invitation_loading",
  INVITATION_INVALID_TITLE: "invitation_invalid_title",
  INVITATION_INVALID_BODY: "invitation_invalid_body",
  INVITATION_ALREADY_ACCEPTED_TITLE: "invitation_already_accepted_title",
  INVITATION_ALREADY_ACCEPTED_BODY: "invitation_already_accepted_body",
  INVITATION_CLAIM_TITLE: "invitation_claim_title",
  INVITATION_CLAIM_SUBTITLE: "invitation_claim_subtitle",
  INVITATION_JOIN_TITLE: "invitation_join_title",
  INVITATION_JOIN_SUBTITLE: "invitation_join_subtitle",
  INVITATION_ACCEPT_BUTTON: "invitation_accept_button",
  INVITATION_ACCEPTED_TITLE: "invitation_accepted_title",
  INVITATION_ACCEPTED_BODY: "invitation_accepted_body",
  INVITATION_ACCEPT_ERROR: "invitation_accept_error",
  INVITATION_PASSWORD_TOO_SHORT: "invitation_password_too_short",
  MY_CLINIC: "my_clinic",
  CLINIC_ADMIN_TITLE: "clinic_admin_title",
  CLINIC_ADMIN_SUBTITLE: "clinic_admin_subtitle",
  CLINIC_ADMIN_TAB_THERAPISTS: "clinic_admin_tab_therapists",
  CLINIC_ADMIN_TAB_PATIENTS: "clinic_admin_tab_patients",
  THERAPISTS_EMPTY_TITLE: "therapists_empty_title",
  THERAPISTS_EMPTY_SUBTITLE: "therapists_empty_subtitle",
  THERAPISTS_LOAD_ERROR: "therapists_load_error",
  PATIENTS_EMPTY_TITLE: "patients_empty_title",
  PATIENTS_EMPTY_SUBTITLE: "patients_empty_subtitle",
  PATIENTS_EMPTY_MINE_TITLE: "patients_empty_mine_title",
  PATIENTS_EMPTY_MINE_SUBTITLE: "patients_empty_mine_subtitle",
  PATIENTS_LOAD_ERROR: "patients_load_error",
  MEMBER_ACTIONS_LABEL: "member_actions_label",
  INVITE_THERAPIST_ACTION: "invite_therapist_action",
  INVITE_THERAPIST_TITLE: "invite_therapist_title",
  INVITE_THERAPIST_DESCRIPTION: "invite_therapist_description",
  INVITE_THERAPIST_SUBMIT: "invite_therapist_submit",
  INVITE_THERAPIST_SUCCESS: "invite_therapist_success",
  INVITE_THERAPIST_ERROR: "invite_therapist_error",
  ACT_AS_THERAPIST_ACTION: "act_as_therapist_action",
  IMPERSONATION_BANNER: "impersonation_banner",
  IMPERSONATION_RETURN: "impersonation_return",
  IMPERSONATION_START_FAILED: "impersonation_start_failed",
  REVOKE_THERAPIST_ACTION: "revoke_therapist_action",
  REVOKE_THERAPIST_TITLE: "revoke_therapist_title",
  REVOKE_THERAPIST_DESCRIPTION: "revoke_therapist_description",
  REVOKE_THERAPIST_CONFIRM: "revoke_therapist_confirm",
  REVOKE_THERAPIST_SUCCESS: "revoke_therapist_success",
  REVOKE_THERAPIST_ERROR: "revoke_therapist_error",
  REINVITE_THERAPIST_ACTION: "reinvite_therapist_action",
  REINVITE_THERAPIST_TITLE: "reinvite_therapist_title",
  REINVITE_THERAPIST_DESCRIPTION: "reinvite_therapist_description",
  REINVITE_THERAPIST_CONFIRM: "reinvite_therapist_confirm",
  PROFILE_EDITED_ELSEWHERE: "profile_edited_elsewhere",
  PATIENTS: "patients",
  PATIENTS_TITLE: "patients_title",
  PATIENTS_SUBTITLE: "patients_subtitle",
  PATIENTS_SEARCH_LABEL: "patients_search_label",
  PATIENTS_THERAPISTS_LABEL: "patients_therapists_label",
  PATIENTS_THERAPISTS_NONE: "patients_therapists_none",
  PATIENTS_THERAPIST_UNNAMED: "patients_therapist_unnamed",
  PATIENTS_THERAPIST_VIA_EVALUATION: "patients_therapist_via_evaluation",
  PATIENTS_THERAPIST_VIA_SERVICE: "patients_therapist_via_service",
  PATIENTS_THERAPIST_VIA_BOTH: "patients_therapist_via_both",
  PATIENTS_NO_MATCHES_TITLE: "patients_no_matches_title",
  PATIENTS_NO_MATCHES_SUBTITLE: "patients_no_matches_subtitle",
  PATIENTS_STATUS_FILTER_LABEL: "patients_status_filter_label",
  PATIENTS_STATUS_FILTER_ALL: "patients_status_filter_all",
  PATIENTS_SHOW_MORE: "patients_show_more",
  PATIENTS_MINE_FILTER_LABEL: "patients_mine_filter_label",
  PATIENTS_COUNT: "patients_count",
  PHONE_LABEL: "phone_label",
  PHONE_NOT_GIVEN: "phone_not_given",
  PHONE_NUMBER_INVALID: "phone_number_invalid",
  EVALUATION_TITLE: "evaluation_title",
  EVALUATION_SUBTITLE: "evaluation_subtitle",
  EVALUATION_NEW: "evaluation_new",
  EVALUATION_FOLLOW_UP_SUBTITLE: "evaluation_follow_up_subtitle",
  EVALUATION_EMAIL_LOCKED_HINT: "evaluation_email_locked_hint",
  EVALUATION_PATIENT_LOAD_ERROR: "evaluation_patient_load_error",
  EVALUATION_STEP_ASSESSMENT: "evaluation_step_assessment",
  EVALUATION_STEP_CONSENT: "evaluation_step_consent",
  EVALUATION_STEP_GDPR: "evaluation_step_gdpr",
  EVALUATION_PATIENT_SECTION: "evaluation_patient_section",
  EVALUATION_ASSESSMENT_SECTION: "evaluation_assessment_section",
  EVALUATION_EMAIL_HINT: "evaluation_email_hint",
  EVALUATION_OCCUPATION_LABEL: "evaluation_occupation_label",
  EVALUATION_AGE_LABEL: "evaluation_age_label",
  EVALUATION_AGE_INVALID: "evaluation_age_invalid",
  EVALUATION_SEX_LABEL: "evaluation_sex_label",
  EVALUATION_SEX_MALE: "evaluation_sex_male",
  EVALUATION_SEX_FEMALE: "evaluation_sex_female",
  EVALUATION_SEX_UNSPECIFIED: "evaluation_sex_unspecified",
  EVALUATION_DATE_LABEL: "evaluation_date_label",
  EVALUATION_REASON_LABEL: "evaluation_reason_label",
  EVALUATION_INVESTIGATIONS_LABEL: "evaluation_investigations_label",
  EVALUATION_PAIN_LEVEL_LABEL: "evaluation_pain_level_label",
  EVALUATION_PAIN_LEVEL_INVALID: "evaluation_pain_level_invalid",
  EVALUATION_PAIN_CHARACTER_LABEL: "evaluation_pain_character_label",
  EVALUATION_MEDICATION_LABEL: "evaluation_medication_label",
  EVALUATION_INJURY_HISTORY_LABEL: "evaluation_injury_history_label",
  EVALUATION_NOTES_LABEL: "evaluation_notes_label",
  EVALUATION_BODY_DIAGRAM_ALT: "evaluation_body_diagram_alt",
  EVALUATION_BODY_DIAGRAM_HINT: "evaluation_body_diagram_hint",
  EVALUATION_BODY_DIAGRAM_DRAW: "evaluation_body_diagram_draw",
  EVALUATION_BODY_DIAGRAM_EDIT: "evaluation_body_diagram_edit",
  EVALUATION_BODY_DIAGRAM_DIALOG_TITLE: "evaluation_body_diagram_dialog_title",
  EVALUATION_BODY_DIAGRAM_UNDO: "evaluation_body_diagram_undo",
  EVALUATION_BODY_DIAGRAM_CLEAR: "evaluation_body_diagram_clear",
  EVALUATION_BODY_DIAGRAM_CANCEL: "evaluation_body_diagram_cancel",
  EVALUATION_BODY_DIAGRAM_DONE: "evaluation_body_diagram_done",
  EVALUATION_CONSENT_TITLE: "evaluation_consent_title",
  EVALUATION_CAPACITY_LABEL: "evaluation_capacity_label",
  EVALUATION_CAPACITY_PATIENT: "evaluation_capacity_patient",
  EVALUATION_CAPACITY_REPRESENTATIVE: "evaluation_capacity_representative",
  EVALUATION_CHILD_AGE_LABEL: "evaluation_child_age_label",
  EVALUATION_CHILD_AGE_REQUIRED: "evaluation_child_age_required",
  EVALUATION_CHILD_AGE_INVALID: "evaluation_child_age_invalid",
  EVALUATION_ADDRESS_LABEL: "evaluation_address_label",
  EVALUATION_ID_SERIES_LABEL: "evaluation_id_series_label",
  EVALUATION_ID_NUMBER_LABEL: "evaluation_id_number_label",
  EVALUATION_REFERRING_DOCTOR_LABEL: "evaluation_referring_doctor_label",
  EVALUATION_CONTRAINDICATIONS_TITLE: "evaluation_contraindications_title",
  EVALUATION_CONTRAINDICATIONS_INTRO: "evaluation_contraindications_intro",
  EVALUATION_CONTRAINDICATION_1: "evaluation_contraindication_1",
  EVALUATION_CONTRAINDICATION_2: "evaluation_contraindication_2",
  EVALUATION_CONTRAINDICATION_3: "evaluation_contraindication_3",
  EVALUATION_CONTRAINDICATION_4: "evaluation_contraindication_4",
  EVALUATION_CONTRAINDICATION_5: "evaluation_contraindication_5",
  EVALUATION_CONTRAINDICATION_6: "evaluation_contraindication_6",
  EVALUATION_CONTRAINDICATION_7: "evaluation_contraindication_7",
  EVALUATION_CONTRAINDICATION_8: "evaluation_contraindication_8",
  EVALUATION_CONTRAINDICATION_9: "evaluation_contraindication_9",
  EVALUATION_CONTRAINDICATION_10: "evaluation_contraindication_10",
  EVALUATION_CONTRAINDICATION_11: "evaluation_contraindication_11",
  EVALUATION_CONTRAINDICATION_12: "evaluation_contraindication_12",
  EVALUATION_CONTRAINDICATION_13: "evaluation_contraindication_13",
  EVALUATION_CONTRAINDICATION_14: "evaluation_contraindication_14",
  EVALUATION_CONTRAINDICATION_15: "evaluation_contraindication_15",
  EVALUATION_CONTRAINDICATION_16: "evaluation_contraindication_16",
  EVALUATION_CONTRAINDICATION_17: "evaluation_contraindication_17",
  EVALUATION_CONTRAINDICATION_18: "evaluation_contraindication_18",
  EVALUATION_TREATMENT_DECLARATION: "evaluation_treatment_declaration",
  EVALUATION_TREATMENT_CONSENT_LABEL: "evaluation_treatment_consent_label",
  EVALUATION_TREATMENT_CONSENT_REQUIRED:
    "evaluation_treatment_consent_required",
  EVALUATION_SIGNED_NAME_LABEL: "evaluation_signed_name_label",
  EVALUATION_SIGNED_NAME_REQUIRED: "evaluation_signed_name_required",
  EVALUATION_SIGNATURE_LABEL: "evaluation_signature_label",
  EVALUATION_SIGNATURE_HINT: "evaluation_signature_hint",
  EVALUATION_SIGNATURE_PLACEHOLDER: "evaluation_signature_placeholder",
  EVALUATION_SIGNATURE_CLEAR: "evaluation_signature_clear",
  EVALUATION_SIGNATURE_REQUIRED: "evaluation_signature_required",
  EVALUATION_GDPR_TITLE: "evaluation_gdpr_title",
  EVALUATION_GDPR_PARAGRAPH_1: "evaluation_gdpr_paragraph_1",
  EVALUATION_GDPR_PARAGRAPH_2: "evaluation_gdpr_paragraph_2",
  EVALUATION_GDPR_PARAGRAPH_3: "evaluation_gdpr_paragraph_3",
  EVALUATION_GDPR_CONSENT_LABEL: "evaluation_gdpr_consent_label",
  EVALUATION_GDPR_CONSENT_REQUIRED: "evaluation_gdpr_consent_required",
  EVALUATION_SUBMIT: "evaluation_submit",
  EVALUATION_SAVED_SUCCESS: "evaluation_saved_success",
  EVALUATION_SAVE_ERROR: "evaluation_save_error",
  EVALUATION_COLUMN_DATE: "evaluation_column_date",
  EVALUATION_COLUMN_REASON: "evaluation_column_reason",
  EVALUATION_COLUMN_PAIN: "evaluation_column_pain",
  EVALUATION_COLUMN_DOCUMENT: "evaluation_column_document",
  EVALUATION_OPEN_PDF: "evaluation_open_pdf",
  EVALUATION_PDF_MISSING: "evaluation_pdf_missing",
  EVALUATION_PDF_ERROR: "evaluation_pdf_error",
  EVALUATION_DELETE: "evaluation_delete",
  EVALUATION_DELETE_CONFIRM_TITLE: "evaluation_delete_confirm_title",
  EVALUATION_DELETE_CONFIRM_MESSAGE: "evaluation_delete_confirm_message",
  EVALUATION_DELETE_SUCCESS: "evaluation_delete_success",
  EVALUATION_DELETE_ERROR: "evaluation_delete_error",
  PATIENTS_OPEN: "patients_open",
  PATIENTS_RESEND_INVITATION_ACTION: "patients_resend_invitation_action",
  PATIENTS_RESEND_INVITATION_TITLE: "patients_resend_invitation_title",
  PATIENTS_RESEND_INVITATION_DESCRIPTION:
    "patients_resend_invitation_description",
  PATIENTS_RESEND_INVITATION_CONFIRM: "patients_resend_invitation_confirm",
  PATIENTS_RESEND_INVITATION_SUCCESS: "patients_resend_invitation_success",
  PATIENTS_RESEND_INVITATION_ERROR: "patients_resend_invitation_error",
  PATIENTS_WITHDRAW_INVITATION_ACTION: "patients_withdraw_invitation_action",
  PATIENTS_WITHDRAW_INVITATION_TITLE: "patients_withdraw_invitation_title",
  PATIENTS_WITHDRAW_INVITATION_DESCRIPTION:
    "patients_withdraw_invitation_description",
  PATIENTS_WITHDRAW_INVITATION_CONFIRM: "patients_withdraw_invitation_confirm",
  PATIENTS_WITHDRAW_INVITATION_SUCCESS: "patients_withdraw_invitation_success",
  PATIENTS_WITHDRAW_INVITATION_ERROR: "patients_withdraw_invitation_error",
  ADD_PATIENT_ACTION: "add_patient_action",
  ADD_PATIENT_TITLE: "add_patient_title",
  ADD_PATIENT_DESCRIPTION: "add_patient_description",
  ADD_PATIENT_SUBMIT: "add_patient_submit",
  ADD_PATIENT_SUCCESS: "add_patient_success",
  ADD_PATIENT_ERROR: "add_patient_error",
  ADD_PATIENT_NOT_SELECTABLE: "add_patient_not_selectable",
  PATIENT_DETAIL_BACK: "patient_detail_back",
  PATIENT_DETAIL_NOT_FOUND: "patient_detail_not_found",
  PATIENT_DETAIL_MEDICAL_RECORDS_TITLE: "patient_detail_medical_records_title",
  PATIENT_DETAIL_MEDICAL_RECORDS_SUBTITLE:
    "patient_detail_medical_records_subtitle",
  PATIENT_DETAIL_MEDICAL_RECORDS_LOAD_ERROR:
    "patient_detail_medical_records_load_error",
  PATIENT_DETAIL_MEDICAL_RECORDS_EMPTY_TITLE:
    "patient_detail_medical_records_empty_title",
  PATIENT_DETAIL_MEDICAL_RECORDS_EMPTY_SUBTITLE:
    "patient_detail_medical_records_empty_subtitle",
  PATIENT_DETAIL_MEDICAL_RECORDS_SHOW_MORE:
    "patient_detail_medical_records_show_more",
  MEDICAL_RECORD_COLUMN_DATE: "medical_record_column_date",
  MEDICAL_RECORD_COLUMN_TYPE: "medical_record_column_type",
  MEDICAL_RECORD_COLUMN_DESCRIPTION: "medical_record_column_description",
  MEDICAL_RECORD_COLUMN_AUTHOR: "medical_record_column_author",
  MEDICAL_RECORD_COLUMN_ACTIONS: "medical_record_column_actions",
  MEDICAL_RECORD_KIND_EVALUATION: "medical_record_kind_evaluation",
  MEDICAL_RECORD_PAIN_LEVEL: "medical_record_pain_level",
  MEDICAL_DOCUMENT_CATEGORY_IMAGING: "medical_document_category_imaging",
  MEDICAL_DOCUMENT_CATEGORY_LAB_RESULTS:
    "medical_document_category_lab_results",
  MEDICAL_DOCUMENT_CATEGORY_REFERRAL: "medical_document_category_referral",
  MEDICAL_DOCUMENT_CATEGORY_DISCHARGE_SUMMARY:
    "medical_document_category_discharge_summary",
  MEDICAL_DOCUMENT_CATEGORY_SURGERY_REPORT:
    "medical_document_category_surgery_report",
  MEDICAL_DOCUMENT_CATEGORY_OTHER: "medical_document_category_other",
  MEDICAL_DOCUMENT_OPEN: "medical_document_open",
  MEDICAL_DOCUMENT_OPEN_ERROR: "medical_document_open_error",
  MEDICAL_DOCUMENT_DELETE: "medical_document_delete",
  MEDICAL_DOCUMENT_DELETE_CONFIRM_TITLE:
    "medical_document_delete_confirm_title",
  MEDICAL_DOCUMENT_DELETE_CONFIRM_MESSAGE:
    "medical_document_delete_confirm_message",
  MEDICAL_DOCUMENT_DELETE_SUCCESS: "medical_document_delete_success",
  MEDICAL_DOCUMENT_DELETE_ERROR: "medical_document_delete_error",
  UPLOAD_DOCUMENTS_BUTTON: "upload_documents_button",
  UPLOAD_DOCUMENTS_TITLE: "upload_documents_title",
  UPLOAD_DOCUMENTS_DESCRIPTION: "upload_documents_description",
  UPLOAD_DOCUMENTS_CHOOSE_FILES: "upload_documents_choose_files",
  UPLOAD_DOCUMENTS_ADD_MORE: "upload_documents_add_more",
  UPLOAD_DOCUMENTS_TAKE_PHOTO: "upload_documents_take_photo",
  UPLOAD_DOCUMENTS_PHOTO_TITLE: "upload_documents_photo_title",
  UPLOAD_DOCUMENTS_REMOVE_FILE: "upload_documents_remove_file",
  UPLOAD_DOCUMENTS_TITLE_LABEL: "upload_documents_title_label",
  UPLOAD_DOCUMENTS_TITLE_REQUIRED: "upload_documents_title_required",
  UPLOAD_DOCUMENTS_CATEGORY_LABEL: "upload_documents_category_label",
  UPLOAD_DOCUMENTS_CATEGORY_REQUIRED: "upload_documents_category_required",
  UPLOAD_DOCUMENTS_ISSUED_ON_LABEL: "upload_documents_issued_on_label",
  UPLOAD_DOCUMENTS_ISSUED_ON_HINT: "upload_documents_issued_on_hint",
  UPLOAD_DOCUMENTS_ISSUED_ON_REQUIRED: "upload_documents_issued_on_required",
  UPLOAD_DOCUMENTS_ISSUED_ON_FUTURE: "upload_documents_issued_on_future",
  UPLOAD_DOCUMENTS_NO_FILES: "upload_documents_no_files",
  UPLOAD_DOCUMENTS_TOO_MANY: "upload_documents_too_many",
  UPLOAD_DOCUMENTS_FILE_TOO_LARGE: "upload_documents_file_too_large",
  UPLOAD_DOCUMENTS_TOTAL_TOO_LARGE: "upload_documents_total_too_large",
  UPLOAD_DOCUMENTS_FILE_TYPE_UNSUPPORTED:
    "upload_documents_file_type_unsupported",
  UPLOAD_DOCUMENTS_UPLOADING: "upload_documents_uploading",
  UPLOAD_DOCUMENTS_SUBMIT: "upload_documents_submit",
  UPLOAD_DOCUMENTS_SUCCESS: "upload_documents_success",
  UPLOAD_DOCUMENTS_ERROR: "upload_documents_error",
  PATIENT_PURCHASES_TITLE: "patient_purchases_title",
  PATIENT_PURCHASES_SUBTITLE: "patient_purchases_subtitle",
  PATIENT_PURCHASES_ADD: "patient_purchases_add",
  PATIENT_PURCHASES_ACTIVE: "patient_purchases_active",
  PATIENT_PURCHASES_HISTORY: "patient_purchases_history",
  PATIENT_PURCHASES_EMPTY_TITLE: "patient_purchases_empty_title",
  PATIENT_PURCHASES_EMPTY_SUBTITLE: "patient_purchases_empty_subtitle",
  PATIENT_PURCHASES_LOAD_ERROR: "patient_purchases_load_error",
  PATIENT_PURCHASES_TAB_EMPTY: "patient_purchases_tab_empty",
  PURCHASE_TYPE_SINGLE: "purchase_type_single",
  PURCHASE_TYPE_PACKAGE: "purchase_type_package",
  PURCHASE_STATUS_ACTIVE: "purchase_status_active",
  PURCHASE_STATUS_COMPLETED: "purchase_status_completed",
  PURCHASE_STATUS_EXPIRED: "purchase_status_expired",
  PURCHASE_STATUS_CANCELLED: "purchase_status_cancelled",
  PURCHASE_SESSIONS_REMAINING: "purchase_sessions_remaining",
  PURCHASE_SESSION_HELD: "purchase_session_held",
  PURCHASE_SESSION_NOT_HELD: "purchase_session_not_held",
  PURCHASE_ASSIGNED_ON: "purchase_assigned_on",
  PURCHASE_VALID_UNTIL: "purchase_valid_until",
  PURCHASE_PER_SESSION: "purchase_per_session",
  PURCHASE_RECORD_SESSION: "purchase_record_session",
  PURCHASE_RECORD_SESSION_SUCCESS: "purchase_record_session_success",
  PURCHASE_RECORD_SESSION_ERROR: "purchase_record_session_error",
  PURCHASE_RECORD_SESSION_TITLE: "purchase_record_session_title",
  PURCHASE_RECORD_SESSION_SUBTITLE: "purchase_record_session_subtitle",
  PURCHASE_RECORD_SESSION_STARTED_AT_LABEL:
    "purchase_record_session_started_at_label",
  PURCHASE_RECORD_SESSION_TIME_REQUIRED:
    "purchase_record_session_time_required",
  PURCHASE_RECORD_SESSION_SUBMIT: "purchase_record_session_submit",
  PURCHASE_SESSION_DURATION: "purchase_session_duration",
  PURCHASE_PLAN_SESSIONS: "purchase_plan_sessions",
  PURCHASE_SOLD_ON: "purchase_sold_on",
  PURCHASE_ALL_BOOKED: "purchase_all_booked",
  PURCHASE_SESSIONS_NONE: "purchase_sessions_none",
  PURCHASE_UNDO_SESSION: "purchase_undo_session",
  PURCHASE_UNDO_SESSION_SUCCESS: "purchase_undo_session_success",
  PURCHASE_UNDO_SESSION_ERROR: "purchase_undo_session_error",
  PURCHASE_CANCEL: "purchase_cancel",
  PURCHASE_CANCEL_SUCCESS: "purchase_cancel_success",
  PURCHASE_CANCEL_ERROR: "purchase_cancel_error",
  PURCHASE_SHOW_SESSIONS: "purchase_show_sessions",
  PURCHASE_HIDE_SESSIONS: "purchase_hide_sessions",
  ADD_PURCHASE_TITLE: "add_purchase_title",
  ADD_PURCHASE_SUBTITLE: "add_purchase_subtitle",
  ADD_PURCHASE_SERVICE_LABEL: "add_purchase_service_label",
  ADD_PURCHASE_GROUP_THIS_SESSION: "add_purchase_group_this_session",
  ADD_PURCHASE_GROUP_PACKAGES: "add_purchase_group_packages",
  ADD_PURCHASE_SERVICE_REQUIRED: "add_purchase_service_required",
  ADD_PURCHASE_THERAPIST_LABEL: "add_purchase_therapist_label",
  ADD_PURCHASE_THERAPIST_REQUIRED: "add_purchase_therapist_required",
  ADD_PURCHASE_SESSIONS_LABEL: "add_purchase_sessions_label",
  ADD_PURCHASE_SESSIONS_MIN: "add_purchase_sessions_min",
  ADD_PURCHASE_LIST_PRICE_LABEL: "add_purchase_list_price_label",
  ADD_PURCHASE_DISCOUNT_PERCENT_LABEL: "add_purchase_discount_percent_label",
  ADD_PURCHASE_FINAL_PRICE_LABEL: "add_purchase_final_price_label",
  ADD_PURCHASE_PRICE_INVALID: "add_purchase_price_invalid",
  ADD_PURCHASE_DISCOUNT_RANGE: "add_purchase_discount_range",
  ADD_PURCHASE_VALID_UNTIL_LABEL: "add_purchase_valid_until_label",
  ADD_PURCHASE_VALID_UNTIL_HINT: "add_purchase_valid_until_hint",
  ADD_PURCHASE_VALID_UNTIL_PAST: "add_purchase_valid_until_past",
  ADD_PURCHASE_SOLD_ON_LABEL: "add_purchase_sold_on_label",
  ADD_PURCHASE_SESSION_HELD_LABEL: "add_purchase_session_held_label",
  ADD_PURCHASE_SESSION_HELD_HINT: "add_purchase_session_held_hint",
  ADD_PURCHASE_PROVIDED_AT_LABEL: "add_purchase_provided_at_label",
  ADD_PURCHASE_TIME_REQUIRED: "add_purchase_time_required",
  ADD_PURCHASE_NOTES_LABEL: "add_purchase_notes_label",
  ADD_PURCHASE_SUBMIT: "add_purchase_submit",
  ADD_PURCHASE_SUCCESS: "add_purchase_success",
  ADD_PURCHASE_ERROR: "add_purchase_error",
  ADD_PURCHASE_SERVICES_LOAD_ERROR: "add_purchase_services_load_error",
  ABOUT_LOAD_ERROR: "about_load_error",
  ABOUT_EDIT_ACTION: "about_edit_action",
  ABOUT_SAVE_ACTION: "about_save_action",
  ABOUT_SAVE_SUCCESS: "about_save_success",
  ABOUT_SAVE_ERROR: "about_save_error",
  ABOUT_DISCARD_TITLE: "about_discard_title",
  ABOUT_DISCARD_DESCRIPTION: "about_discard_description",
  ABOUT_DISCARD_CONFIRM: "about_discard_confirm",
  ABOUT_BLOCKED_SAVE: "about_blocked_save",
  ABOUT_EMPTY_TITLE: "about_empty_title",
  ABOUT_EMPTY_SUBTITLE: "about_empty_subtitle",
  ABOUT_EMPTY_ADMIN_SUBTITLE: "about_empty_admin_subtitle",
  PLATFORM_ABOUT_TITLE: "platform_about_title",
  PLATFORM_ABOUT_SUBTITLE: "platform_about_subtitle",
  PLATFORM_ABOUT_MISSION_TITLE: "platform_about_mission_title",
  PLATFORM_ABOUT_MISSION_BODY: "platform_about_mission_body",
  PLATFORM_ABOUT_FEATURES_TITLE: "platform_about_features_title",
  PLATFORM_ABOUT_FEATURE_BOOKING_TITLE: "platform_about_feature_booking_title",
  PLATFORM_ABOUT_FEATURE_BOOKING_DESC: "platform_about_feature_booking_desc",
  PLATFORM_ABOUT_FEATURE_EVALUATIONS_TITLE:
    "platform_about_feature_evaluations_title",
  PLATFORM_ABOUT_FEATURE_EVALUATIONS_DESC:
    "platform_about_feature_evaluations_desc",
  PLATFORM_ABOUT_FEATURE_PACKAGES_TITLE:
    "platform_about_feature_packages_title",
  PLATFORM_ABOUT_FEATURE_PACKAGES_DESC: "platform_about_feature_packages_desc",
  PLATFORM_ABOUT_FEATURE_INVOICING_TITLE:
    "platform_about_feature_invoicing_title",
  PLATFORM_ABOUT_FEATURE_INVOICING_DESC:
    "platform_about_feature_invoicing_desc",
  PLATFORM_ABOUT_FEATURE_REMINDERS_TITLE:
    "platform_about_feature_reminders_title",
  PLATFORM_ABOUT_FEATURE_REMINDERS_DESC:
    "platform_about_feature_reminders_desc",
  PLATFORM_ABOUT_FEATURE_IDENTITY_TITLE:
    "platform_about_feature_identity_title",
  PLATFORM_ABOUT_FEATURE_IDENTITY_DESC: "platform_about_feature_identity_desc",
  PLATFORM_ABOUT_SERVICES_TITLE: "platform_about_services_title",
  PLATFORM_ABOUT_ROLE_ADMIN_TITLE: "platform_about_role_admin_title",
  PLATFORM_ABOUT_ROLE_ADMIN_DESC: "platform_about_role_admin_desc",
  PLATFORM_ABOUT_ROLE_THERAPIST_TITLE: "platform_about_role_therapist_title",
  PLATFORM_ABOUT_ROLE_THERAPIST_DESC: "platform_about_role_therapist_desc",
  PLATFORM_ABOUT_ROLE_PATIENT_TITLE: "platform_about_role_patient_title",
  PLATFORM_ABOUT_ROLE_PATIENT_DESC: "platform_about_role_patient_desc",
  PLATFORM_ABOUT_CTA_TITLE: "platform_about_cta_title",
  PLATFORM_ABOUT_CTA_SUBTITLE: "platform_about_cta_subtitle",
  PLATFORM_ABOUT_CTA_CONTACT: "platform_about_cta_contact",
  ABOUT_FIELD_RO: "about_field_ro",
  ABOUT_FIELD_EN: "about_field_en",
  ABOUT_SECTION_INTRO: "about_section_intro",
  ABOUT_SECTION_MISSION: "about_section_mission",
  ABOUT_SECTION_FEATURES: "about_section_features",
  ABOUT_SECTION_SERVICES: "about_section_services",
  ABOUT_SECTION_CTA: "about_section_cta",
  ABOUT_FIELD_TITLE: "about_field_title",
  ABOUT_FIELD_SUBTITLE: "about_field_subtitle",
  ABOUT_FIELD_MISSION_TITLE: "about_field_mission_title",
  ABOUT_FIELD_MISSION_BODY: "about_field_mission_body",
  ABOUT_FIELD_FEATURES_TITLE: "about_field_features_title",
  ABOUT_FIELD_SERVICES_TITLE: "about_field_services_title",
  ABOUT_FIELD_CTA_TITLE: "about_field_cta_title",
  ABOUT_FIELD_CTA_SUBTITLE: "about_field_cta_subtitle",
  ABOUT_FIELD_CTA_CONTACT: "about_field_cta_contact",
  ABOUT_CARD_LABEL: "about_card_label",
  ABOUT_CARD_ICON: "about_card_icon",
  ABOUT_CARD_TITLE: "about_card_title",
  ABOUT_CARD_BODY: "about_card_body",
  ABOUT_ADD_FEATURE: "about_add_feature",
  ABOUT_ADD_SERVICE: "about_add_service",
  ABOUT_DELETE_CARD: "about_delete_card",
  ABOUT_DELETE_TITLE: "about_delete_title",
  ABOUT_DELETE_DESCRIPTION: "about_delete_description",
  ABOUT_MOVE_UP: "about_move_up",
  ABOUT_MOVE_DOWN: "about_move_down",
  ABOUT_REQUIRED_ERROR: "about_required_error",
  ABOUT_NO_FEATURES: "about_no_features",
  ABOUT_NO_SERVICES: "about_no_services",
  CLINIC_DASHBOARD_NAV: "clinic_dashboard_nav",
  CLINIC_DASHBOARD_TITLE: "clinic_dashboard_title",
  CLINIC_DASHBOARD_SUBTITLE: "clinic_dashboard_subtitle",
  CLINIC_DASHBOARD_LOAD_ERROR: "clinic_dashboard_load_error",
  CLINIC_DASHBOARD_EMPTY_TITLE: "clinic_dashboard_empty_title",
  CLINIC_DASHBOARD_EMPTY_SUBTITLE: "clinic_dashboard_empty_subtitle",
  DASHBOARD_PERIOD_RANGE: "dashboard_period_range",
  DASHBOARD_INCOME_MODE_LABEL: "dashboard_income_mode_label",
  DASHBOARD_INCOME_BILLED: "dashboard_income_billed",
  DASHBOARD_INCOME_EARNED: "dashboard_income_earned",
  DASHBOARD_INCOME_BILLED_HELP: "dashboard_income_billed_help",
  DASHBOARD_INCOME_EARNED_HELP: "dashboard_income_earned_help",
  DASHBOARD_KPI_INCOME: "dashboard_kpi_income",
  DASHBOARD_KPI_DEFERRED: "dashboard_kpi_deferred",
  DASHBOARD_KPI_DEFERRED_HELP: "dashboard_kpi_deferred_help",
  DASHBOARD_KPI_NEW_PATIENTS: "dashboard_kpi_new_patients",
  DASHBOARD_KPI_RETURNING_PATIENTS: "dashboard_kpi_returning_patients",
  DASHBOARD_KPI_ACTIVE_PATIENTS: "dashboard_kpi_active_patients",
  DASHBOARD_KPI_SESSIONS_HELD: "dashboard_kpi_sessions_held",
  DASHBOARD_KPI_PURCHASES_SOLD: "dashboard_kpi_purchases_sold",
  DASHBOARD_MONEY: "dashboard_money",
  DASHBOARD_CHART_PATIENTS_TITLE: "dashboard_chart_patients_title",
  DASHBOARD_CHART_EMPTY: "dashboard_chart_empty",
  DASHBOARD_THERAPIST_UNASSIGNED: "dashboard_therapist_unassigned",
  DASHBOARD_TABLE_THERAPIST: "dashboard_table_therapist",
  DASHBOARD_TABLE_NEW: "dashboard_table_new",
  DASHBOARD_TABLE_RETURNING: "dashboard_table_returning",
  DASHBOARD_YEAR_LABEL: "dashboard_year_label",
  DASHBOARD_CHART_INCOME_TITLE: "dashboard_chart_income_title",
  DASHBOARD_CHART_INCOME_SUBTITLE: "dashboard_chart_income_subtitle",
  DASHBOARD_CHART_PATIENTS_SUBTITLE: "dashboard_chart_patients_subtitle",
  DASHBOARD_CHART_ACTIVE_PATIENTS_NOTE: "dashboard_chart_active_patients_note",
  DASHBOARD_SERIES_TOTAL: "dashboard_series_total",
  DASHBOARD_SERIES_ACTIVE: "dashboard_series_active",
  DASHBOARD_LEGEND_LABEL: "dashboard_legend_label",
  DASHBOARD_LEGEND_SHOW: "dashboard_legend_show",
  DASHBOARD_LEGEND_HIDE: "dashboard_legend_hide",
  DASHBOARD_LEGEND_LAST_SERIES: "dashboard_legend_last_series",
  DASHBOARD_CHART_SCROLL_HINT: "dashboard_chart_scroll_hint",
  THERAPIST_INCOME_NAV: "therapist_income_nav",
  THERAPIST_INCOME_TITLE: "therapist_income_title",
  THERAPIST_INCOME_SUBTITLE: "therapist_income_subtitle",
  THERAPIST_INCOME_BILLED_CAPTION: "therapist_income_billed_caption",
  THERAPIST_INCOME_EARNED_CAPTION: "therapist_income_earned_caption",
  THERAPIST_INCOME_LOAD_ERROR: "therapist_income_load_error",
  THERAPIST_INCOME_EMPTY_TITLE: "therapist_income_empty_title",
  THERAPIST_INCOME_EMPTY_SUBTITLE: "therapist_income_empty_subtitle",
  THERAPIST_INCOME_CHART_TITLE: "therapist_income_chart_title",
  THERAPIST_INCOME_CHART_SUBTITLE: "therapist_income_chart_subtitle",
  APPOINTMENT_STATUS_SCHEDULED: "appointment_status_scheduled",
  APPOINTMENT_STATUS_HELD: "appointment_status_held",
  APPOINTMENT_STATUS_NO_SHOW: "appointment_status_no_show",
  APPOINTMENT_STATUS_CANCELLED: "appointment_status_cancelled",
  APPOINTMENT_STATUS_REQUESTED: "appointment_status_requested",
  APPOINTMENT_STATUS_DECLINED: "appointment_status_declined",
  PURCHASE_SESSIONS_BOOKED: "purchase_sessions_booked",
  PURCHASE_USED_BEFORE: "purchase_used_before",
  PURCHASE_USED_BEFORE_ADJUST: "purchase_used_before_adjust",
  PURCHASE_USED_BEFORE_TITLE: "purchase_used_before_title",
  PURCHASE_USED_BEFORE_DESCRIPTION: "purchase_used_before_description",
  PURCHASE_USED_BEFORE_LABEL: "purchase_used_before_label",
  PURCHASE_USED_BEFORE_HINT: "purchase_used_before_hint",
  PURCHASE_USED_BEFORE_RANGE: "purchase_used_before_range",
  PURCHASE_USED_BEFORE_SUCCESS: "purchase_used_before_success",
  PURCHASE_USED_BEFORE_ERROR: "purchase_used_before_error",
  MY_CALENDAR_TITLE: "my_calendar_title",
  MY_CALENDAR_PREVIOUS: "my_calendar_previous",
  MY_CALENDAR_NEXT: "my_calendar_next",
  MY_CALENDAR_TODAY: "my_calendar_today",
  MY_CALENDAR_EMPTY: "my_calendar_empty",
  MY_CALENDAR_NEEDS_RESOLVING: "my_calendar_needs_resolving",
  MY_CALENDAR_NAV: "my_calendar_nav",
  MY_CALENDAR_SHOW_CANCELLED: "my_calendar_show_cancelled",
  MY_CALENDAR_VIEW_DAY: "my_calendar_view_day",
  MY_CALENDAR_VIEW_WEEK: "my_calendar_view_week",
  MY_CALENDAR_PREVIOUS_WEEK: "my_calendar_previous_week",
  MY_CALENDAR_NEXT_WEEK: "my_calendar_next_week",
  MY_CALENDAR_THIS_WEEK: "my_calendar_this_week",
  MY_CALENDAR_WEEK_EMPTY: "my_calendar_week_empty",
  MY_CALENDAR_SCROLL_HINT: "my_calendar_scroll_hint",
  MY_CALENDAR_GRID_LABEL: "my_calendar_grid_label",
  APPOINTMENT_TIME_BLOCK: "appointment_time_block",
  APPOINTMENT_MARK_HELD: "appointment_mark_held",
  APPOINTMENT_MARK_NO_SHOW: "appointment_mark_no_show",
  APPOINTMENT_CANCEL: "appointment_cancel",
  APPOINTMENT_REOPEN: "appointment_reopen",
  APPOINTMENT_UPDATED: "appointment_updated",
  APPOINTMENT_UPDATE_FAILED: "appointment_update_failed",
  APPOINTMENT_RESCHEDULE: "appointment_reschedule",
  APPOINTMENT_RESCHEDULE_TITLE: "appointment_reschedule_title",
  APPOINTMENT_RESCHEDULE_CURRENT: "appointment_reschedule_current",
  APPOINTMENT_RESCHEDULE_PICK_SLOT: "appointment_reschedule_pick_slot",
  APPOINTMENT_RESCHEDULE_STARTS_AT: "appointment_reschedule_starts_at",
  APPOINTMENT_RESCHEDULE_TIME: "appointment_reschedule_time",
  APPOINTMENT_RESCHEDULE_KEEPS_LENGTH: "appointment_reschedule_keeps_length",
  APPOINTMENT_RESCHEDULE_STARTS_AT_REQUIRED:
    "appointment_reschedule_starts_at_required",
  APPOINTMENT_RESCHEDULE_CONFIRM: "appointment_reschedule_confirm",
  APPOINTMENT_RESCHEDULED: "appointment_rescheduled",
  APPOINTMENT_RESCHEDULE_FAILED: "appointment_reschedule_failed",
  MY_APPOINTMENTS_UPCOMING: "my_appointments_upcoming",
  MY_APPOINTMENTS_PAST: "my_appointments_past",
  MY_APPOINTMENTS_NONE_UPCOMING: "my_appointments_none_upcoming",
  MY_APPOINTMENTS_NONE_PAST: "my_appointments_none_past",
  MY_APPOINTMENTS_NO_MATCHES: "my_appointments_no_matches",
  MY_APPOINTMENTS_STATUS_FILTER_LABEL: "my_appointments_status_filter_label",
  MY_APPOINTMENTS_STATUS_FILTER_ALL: "my_appointments_status_filter_all",
  MY_APPOINTMENTS_SHOW_MORE: "my_appointments_show_more",
  BOOK_APPOINTMENT_SUBTITLE: "book_appointment_subtitle",
  BOOK_APPOINTMENT_STEP_SERVICE: "book_appointment_step_service",
  BOOK_APPOINTMENT_STEP_THERAPIST: "book_appointment_step_therapist",
  BOOK_APPOINTMENT_STEP_SLOT: "book_appointment_step_slot",
  BOOK_APPOINTMENT_DAY: "book_appointment_day",
  BOOK_APPOINTMENT_SLOT_LABEL: "book_appointment_slot_label",
  PICKER_TIME_LABEL: "picker_time_label",
  BOOK_APPOINTMENT_CONFIRM: "book_appointment_confirm",
  BOOK_APPOINTMENT_NO_THERAPISTS: "book_appointment_no_therapists",
  BOOK_APPOINTMENT_YOUR_THERAPIST: "book_appointment_your_therapist",
  BOOK_APPOINTMENT_OTHER_THERAPISTS: "book_appointment_other_therapists",
  BOOK_APPOINTMENT_NO_SLOTS: "book_appointment_no_slots",
  BOOK_APPOINTMENT_ENTITLEMENT: "book_appointment_entitlement",
  BOOK_APPOINTMENT_NOTHING_LEFT: "book_appointment_nothing_left",
  BOOK_APPOINTMENT_SERVICE_REQUIRED: "book_appointment_service_required",
  BOOK_APPOINTMENT_THERAPIST_REQUIRED: "book_appointment_therapist_required",
  BOOK_APPOINTMENT_DAY_REQUIRED: "book_appointment_day_required",
  BOOK_APPOINTMENT_SLOT_REQUIRED: "book_appointment_slot_required",
  BOOK_APPOINTMENT_WEEK_PREVIOUS: "book_appointment_week_previous",
  BOOK_APPOINTMENT_WEEK_NEXT: "book_appointment_week_next",
  BOOK_APPOINTMENT_WEEK_RANGE: "book_appointment_week_range",
  BOOK_APPOINTMENT_DAY_FREE_COUNT: "book_appointment_day_free_count",
  BOOK_APPOINTMENT_DAY_FULL: "book_appointment_day_full",
  BOOK_APPOINTMENT_DAY_PAST: "book_appointment_day_past",
  BOOK_APPOINTMENT_PERIOD_MORNING: "book_appointment_period_morning",
  BOOK_APPOINTMENT_PERIOD_AFTERNOON: "book_appointment_period_afternoon",
  BOOK_APPOINTMENT_PERIOD_EVENING: "book_appointment_period_evening",
  BOOK_APPOINTMENT_NO_SLOTS_THIS_WEEK: "book_appointment_no_slots_this_week",
  BOOK_APPOINTMENT_NOTICE_HINT: "book_appointment_notice_hint",
  APPOINTMENT_BOOK_FAILED: "appointment_book_failed",
  BOOK_APPOINTMENT_REQUEST_HINT: "book_appointment_request_hint",
  APPOINTMENT_REQUEST_SENT: "appointment_request_sent",
  APPOINTMENT_REQUEST_ANSWER_HINT: "appointment_request_answer_hint",
  APPOINTMENT_REQUEST_AWAITING: "appointment_request_awaiting",
  APPOINTMENT_REQUEST_RESPOND_BY: "appointment_request_respond_by",
  APPOINTMENT_REQUEST_LAPSED: "appointment_request_lapsed",
  APPOINTMENT_REQUEST_OTHER_THERAPIST: "appointment_request_other_therapist",
  APPOINTMENT_REQUEST_CONFIRM: "appointment_request_confirm",
  APPOINTMENT_REQUEST_DECLINE: "appointment_request_decline",
  APPOINTMENT_REQUEST_CANCEL: "appointment_request_cancel",
  APPOINTMENT_REQUEST_CONFIRMED: "appointment_request_confirmed",
  APPOINTMENT_REQUEST_DECLINED: "appointment_request_declined",
  APPOINTMENT_REQUEST_ACTION_FAILED: "appointment_request_action_failed",
  DECLINE_REQUEST_TITLE: "decline_request_title",
  DECLINE_REQUEST_DESCRIPTION: "decline_request_description",
  DECLINE_REQUEST_REASON_LABEL: "decline_request_reason_label",
  DECLINE_REQUEST_REASON_HINT: "decline_request_reason_hint",
  DECLINE_REQUEST_REASON_TOO_LONG: "decline_request_reason_too_long",
  DECLINE_REQUEST_SUBMIT: "decline_request_submit",
  APPOINTMENT_DECLINED_NOTE: "appointment_declined_note",
  APPOINTMENT_DECLINED_PLAIN: "appointment_declined_plain",
  APPOINTMENT_DECLINED_AUTOMATICALLY: "appointment_declined_automatically",
  APPOINTMENT_WITHDRAW: "appointment_withdraw",
  APPOINTMENT_WITHDRAW_TITLE: "appointment_withdraw_title",
  APPOINTMENT_WITHDRAW_DESCRIPTION: "appointment_withdraw_description",
  APPOINTMENT_WITHDRAW_KEEP: "appointment_withdraw_keep",
  APPOINTMENT_WITHDRAWN: "appointment_withdrawn",
  APPOINTMENT_WITHDRAW_FAILED: "appointment_withdraw_failed",
  APPOINTMENT_RESCHEDULE_CONFIRMED_WARNING:
    "appointment_reschedule_confirmed_warning",
  APPOINTMENT_RESCHEDULE_REQUEST_INFO: "appointment_reschedule_request_info",
  APPOINTMENT_MOVE_REQUESTED: "appointment_move_requested",
  PENDING_REQUESTS_TITLE: "pending_requests_title",
  PENDING_REQUESTS_SUBTITLE: "pending_requests_subtitle",
  PENDING_REQUESTS_SHOW_MORE: "pending_requests_show_more",
  NOTIFICATIONS_TITLE: "notifications_title",
  NOTIFICATIONS_BELL_LABEL_COUNT: "notifications_bell_label_count",
  NOTIFICATIONS_MARK_ALL_READ: "notifications_mark_all_read",
  NOTIFICATIONS_EMPTY: "notifications_empty",
  NOTIFICATIONS_UNREAD: "notifications_unread",
  NOTIFICATIONS_OPEN_FAILED: "notifications_open_failed",
  PUSH_SECTION_TITLE: "push_section_title",
  PUSH_SECTION_DESCRIPTION: "push_section_description",
  PUSH_SWITCH_LABEL: "push_switch_label",
  PUSH_BLOCKED: "push_blocked",
  PUSH_IOS_HINT: "push_ios_hint",
  PUSH_FAILED: "push_failed",
  PUSH_BELL_LINK: "push_bell_link",
  NOTIFICATION_MOVED_FROM: "notification_moved_from",
  NOTIFICATION_GENERIC: "notification_generic",
  NOTIFICATION_PATIENT_BOOKED: "notification_patient_booked",
  NOTIFICATION_PATIENT_CANCELLED: "notification_patient_cancelled",
  NOTIFICATION_PATIENT_MOVED: "notification_patient_moved",
  NOTIFICATION_PATIENT_CONFIRMED: "notification_patient_confirmed",
  NOTIFICATION_PATIENT_DECLINED: "notification_patient_declined",
  NOTIFICATION_PATIENT_EXPIRED: "notification_patient_expired",
  NOTIFICATION_THERAPIST_BOOKED: "notification_therapist_booked",
  NOTIFICATION_THERAPIST_CANCELLED: "notification_therapist_cancelled",
  NOTIFICATION_THERAPIST_MOVED: "notification_therapist_moved",
  NOTIFICATION_THERAPIST_EXPIRED: "notification_therapist_expired",
  NOTIFICATION_THERAPIST_WITHDRAWN: "notification_therapist_withdrawn",
  APPOINTMENT_WHICH_PURCHASE: "appointment_which_purchase",
  APPOINTMENT_PURCHASE_OPTION: "appointment_purchase_option",
  APPOINTMENT_DRAWS_DOWN: "appointment_draws_down",
  APPOINTMENT_PAY_AT_END_OPTION: "appointment_pay_at_end_option",
  CLOSE_DIALOG: "close_dialog",
  MY_CALENDAR_ADD: "my_calendar_add",
  MY_CALENDAR_ADD_BOOKING: "my_calendar_add_booking",
  MY_CALENDAR_ADD_BLOCK: "my_calendar_add_block",
  MY_CALENDAR_ADD_PATIENT: "my_calendar_add_patient",
  MY_CALENDAR_ADD_SERVICE: "my_calendar_add_service",
  MY_CALENDAR_ADD_THERAPIST_HINT: "my_calendar_add_therapist_hint",
  MY_CALENDAR_ADD_THERAPIST_NONE: "my_calendar_add_therapist_none",
  MY_CALENDAR_ADD_PLANS: "my_calendar_add_plans",
  MY_CALENDAR_ADD_DRAWS_DOWN_HINT: "my_calendar_add_draws_down_hint",
  MY_CALENDAR_ADD_NO_PURCHASE: "my_calendar_add_no_purchase",
  MY_CALENDAR_ADD_STARTS_AT: "my_calendar_add_starts_at",
  MY_CALENDAR_ADD_MINUTES: "my_calendar_add_minutes",
  MY_CALENDAR_ADD_CONFIRM: "my_calendar_add_confirm",
  MY_CALENDAR_ADD_BLOCK_HINT: "my_calendar_add_block_hint",
  MY_CALENDAR_ADD_PATIENT_REQUIRED: "my_calendar_add_patient_required",
  MY_CALENDAR_ADD_SERVICE_REQUIRED: "my_calendar_add_service_required",
  MY_CALENDAR_ADD_THERAPIST_REQUIRED: "my_calendar_add_therapist_required",
  MY_CALENDAR_ADD_STARTS_AT_REQUIRED: "my_calendar_add_starts_at_required",
  MY_CALENDAR_ADD_MINUTES_INVALID: "my_calendar_add_minutes_invalid",
  MY_CALENDAR_ADD_UNTIL: "my_calendar_add_until",
  MY_CALENDAR_ADD_UNTIL_TIME: "my_calendar_add_until_time",
  MY_CALENDAR_ADD_UNTIL_REQUIRED: "my_calendar_add_until_required",
  MY_CALENDAR_ADD_UNTIL_AFTER_START: "my_calendar_add_until_after_start",
  MY_CALENDAR_ADD_UNTIL_TOO_LONG: "my_calendar_add_until_too_long",
  MY_CALENDAR_ADD_THERAPIST_GIVES: "my_calendar_add_therapist_gives",
  MY_CALENDAR_ADD_THERAPIST_OTHERS: "my_calendar_add_therapist_others",
  MY_CALENDAR_ADD_THERAPIST_NOT_QUALIFIED:
    "my_calendar_add_therapist_not_qualified",
  MY_CALENDAR_ADD_FREE_COUNT: "my_calendar_add_free_count",
  MY_CALENDAR_ADD_NO_FREE: "my_calendar_add_no_free",
  MY_CALENDAR_ADD_TIMES_LOADING: "my_calendar_add_times_loading",
  MY_CALENDAR_BLOCK_REMOVE: "my_calendar_block_remove",
  MY_CALENDAR_BLOCK_REMOVE_TITLE: "my_calendar_block_remove_title",
  MY_CALENDAR_BLOCK_REMOVE_DESCRIPTION: "my_calendar_block_remove_description",
  MY_CALENDAR_BLOCK_REMOVED: "my_calendar_block_removed",
  MY_CALENDAR_BLOCK_REMOVE_FAILED: "my_calendar_block_remove_failed",
  MY_CALENDAR_ENTRY_ADDED: "my_calendar_entry_added",
  MY_CALENDAR_ENTRY_ADDED_FOR: "my_calendar_entry_added_for",
  MY_CALENDAR_ENTRY_FAILED: "my_calendar_entry_failed",
  CLINIC_ADMIN_TAB_BRANDING: "clinic_admin_tab_branding",
  BRANDING_COLOURS_TITLE: "branding_colours_title",
  BRANDING_COLOURS_HINT: "branding_colours_hint",
  BRANDING_PRIMARY_LABEL: "branding_primary_label",
  BRANDING_SECONDARY_LABEL: "branding_secondary_label",
  BRANDING_COLOUR_INVALID: "branding_colour_invalid",
  BRANDING_CONTRAST_WARNING: "branding_contrast_warning",
  BRANDING_PREVIEW_TITLE: "branding_preview_title",
  BRANDING_PREVIEW_HINT: "branding_preview_hint",
  BRANDING_PREVIEW_MASTHEAD: "branding_preview_masthead",
  BRANDING_PREVIEW_PRIMARY_ACTION: "branding_preview_primary_action",
  BRANDING_PREVIEW_SECONDARY_ACTION: "branding_preview_secondary_action",
  BRANDING_PREVIEW_OUTLINED_ACTION: "branding_preview_outlined_action",
  BRANDING_PREVIEW_CHIP: "branding_preview_chip",
  BRANDING_PREVIEW_EYEBROW: "branding_preview_eyebrow",
  BRANDING_PREVIEW_CARD_TITLE: "branding_preview_card_title",
  BRANDING_PREVIEW_CARD_BODY: "branding_preview_card_body",
  BRANDING_LOGO_TITLE: "branding_logo_title",
  BRANDING_LOGO_HINT: "branding_logo_hint",
  BRANDING_LOGO_UPLOAD: "branding_logo_upload",
  BRANDING_LOGO_REMOVE: "branding_logo_remove",
  BRANDING_LOGO_EDIT: "branding_logo_edit",
  BRANDING_LOGO_EDIT_ERROR: "branding_logo_edit_error",
  BRANDING_LOGO_NONE: "branding_logo_none",
  BRANDING_LOGO_CROP_TITLE: "branding_logo_crop_title",
  BRANDING_LOGO_CROP_HINT: "branding_logo_crop_hint",
  BRANDING_LOGO_CROP_ZOOM: "branding_logo_crop_zoom",
  BRANDING_LOGO_CROP_RESET: "branding_logo_crop_reset",
  BRANDING_LOGO_CROP_PREVIEW_TRANSPARENCY:
    "branding_logo_crop_preview_transparency",
  BRANDING_LOGO_CROP_PREVIEW_HEADER: "branding_logo_crop_preview_header",
  BRANDING_LOGO_CROP_OPAQUE_WARNING: "branding_logo_crop_opaque_warning",
  BRANDING_LOGO_CROP_UNREADABLE: "branding_logo_crop_unreadable",
  BRANDING_LOGO_CROP_ERROR: "branding_logo_crop_error",
  BRANDING_LOGO_CROP_CANCEL: "branding_logo_crop_cancel",
  BRANDING_LOGO_CROP_SAVE: "branding_logo_crop_save",
  BRANDING_SAVE: "branding_save",
  BRANDING_RESET: "branding_reset",
  BRANDING_SAVE_SUCCESS: "branding_save_success",
  BRANDING_SAVE_ERROR: "branding_save_error",
  BRANDING_LOGO_SUCCESS: "branding_logo_success",
  BRANDING_LOGO_REMOVED: "branding_logo_removed",
  BRANDING_LOGO_ERROR: "branding_logo_error",
  BRANDING_FAVICON_TITLE: "branding_favicon_title",
  BRANDING_FAVICON_HINT: "branding_favicon_hint",
  BRANDING_FAVICON_UPLOAD: "branding_favicon_upload",
  BRANDING_FAVICON_EDIT: "branding_favicon_edit",
  BRANDING_FAVICON_REMOVE: "branding_favicon_remove",
  BRANDING_FAVICON_NONE: "branding_favicon_none",
  BRANDING_FAVICON_EDIT_ERROR: "branding_favicon_edit_error",
  BRANDING_FAVICON_CROP_TITLE: "branding_favicon_crop_title",
  BRANDING_FAVICON_CROP_HINT: "branding_favicon_crop_hint",
  BRANDING_FAVICON_CROP_PREVIEW_TAB: "branding_favicon_crop_preview_tab",
  BRANDING_FAVICON_CROP_SAVE: "branding_favicon_crop_save",
  BRANDING_FAVICON_SUCCESS: "branding_favicon_success",
  BRANDING_FAVICON_REMOVED: "branding_favicon_removed",
  BRANDING_FAVICON_ERROR: "branding_favicon_error",
  BRANDING_WATERMARK_TITLE: "branding_watermark_title",
  BRANDING_WATERMARK_HINT: "branding_watermark_hint",
  BRANDING_WATERMARK_UPLOAD: "branding_watermark_upload",
  BRANDING_WATERMARK_EDIT: "branding_watermark_edit",
  BRANDING_WATERMARK_REMOVE: "branding_watermark_remove",
  BRANDING_WATERMARK_EDIT_ERROR: "branding_watermark_edit_error",
  BRANDING_WATERMARK_FALLBACK_LOGO: "branding_watermark_fallback_logo",
  BRANDING_WATERMARK_FALLBACK_NONE: "branding_watermark_fallback_none",
  BRANDING_WATERMARK_OPACITY_LABEL: "branding_watermark_opacity_label",
  BRANDING_WATERMARK_SCALE_LABEL: "branding_watermark_scale_label",
  BRANDING_WATERMARK_OPACITY_INVALID: "branding_watermark_opacity_invalid",
  BRANDING_WATERMARK_SCALE_INVALID: "branding_watermark_scale_invalid",
  BRANDING_WATERMARK_PREVIEW_LABEL: "branding_watermark_preview_label",
  BRANDING_WATERMARK_PREVIEW_HEADING: "branding_watermark_preview_heading",
  BRANDING_WATERMARK_PREVIEW_BODY: "branding_watermark_preview_body",
  BRANDING_WATERMARK_CROP_TITLE: "branding_watermark_crop_title",
  BRANDING_WATERMARK_CROP_SAVE: "branding_watermark_crop_save",
  BRANDING_WATERMARK_CROP_PREVIEW_PAGE: "branding_watermark_crop_preview_page",
  BRANDING_WATERMARK_CROP_OPAQUE_WARNING:
    "branding_watermark_crop_opaque_warning",
  BRANDING_WATERMARK_SUCCESS: "branding_watermark_success",
  BRANDING_WATERMARK_REMOVED: "branding_watermark_removed",
  BRANDING_WATERMARK_ERROR: "branding_watermark_error",
  BRANDING_SOCIAL_TITLE: "branding_social_title",
  BRANDING_SOCIAL_HINT: "branding_social_hint",
  BRANDING_SOCIAL_INSTAGRAM_LABEL: "branding_social_instagram_label",
  BRANDING_SOCIAL_FACEBOOK_LABEL: "branding_social_facebook_label",
  BRANDING_SOCIAL_WHATSAPP_LABEL: "branding_social_whatsapp_label",
  BRANDING_SOCIAL_MAPS_LABEL: "branding_social_maps_label",
  BRANDING_SOCIAL_URL_INVALID: "branding_social_url_invalid",
  BRANDING_SOCIAL_WHATSAPP_INVALID: "branding_social_whatsapp_invalid",
  BRANDING_CONTACT_EMAIL_LABEL: "branding_contact_email_label",
  BRANDING_CONTACT_EMAIL_HINT: "branding_contact_email_hint",
  BRANDING_CONTACT_EMAIL_INVALID: "branding_contact_email_invalid",
  FOOTER_INSTAGRAM: "footer_instagram",
  FOOTER_FACEBOOK: "footer_facebook",
  FOOTER_WHATSAPP: "footer_whatsapp",
  FOOTER_MAPS: "footer_maps",
  TERMS_EYEBROW: "terms_eyebrow",
  TERMS_TITLE: "terms_title",
  TERMS_INTRO: "terms_intro",
  TERMS_LAST_UPDATED: "terms_last_updated",
  TERMS_TOC_TITLE: "terms_toc_title",
  TERMS_DEV_PLACEHOLDER_WARNING: "terms_dev_placeholder_warning",
  TERMS_S1_TITLE: "terms_s1_title",
  TERMS_S1_P1: "terms_s1_p1",
  TERMS_S1_P2: "terms_s1_p2",
  TERMS_S1_P3: "terms_s1_p3",
  TERMS_S1_LI1: "terms_s1_li1",
  TERMS_S1_LI2: "terms_s1_li2",
  TERMS_S1_LI3: "terms_s1_li3",
  TERMS_S1_LI4: "terms_s1_li4",
  TERMS_S1_LI5: "terms_s1_li5",
  TERMS_S2_TITLE: "terms_s2_title",
  TERMS_S2_P1: "terms_s2_p1",
  TERMS_S2_P2: "terms_s2_p2",
  TERMS_S2_P3: "terms_s2_p3",
  TERMS_S2_P4: "terms_s2_p4",
  TERMS_S3_TITLE: "terms_s3_title",
  TERMS_S3_P1: "terms_s3_p1",
  TERMS_S3_P2: "terms_s3_p2",
  TERMS_S3_P3: "terms_s3_p3",
  TERMS_S3_P4: "terms_s3_p4",
  TERMS_S3_P5: "terms_s3_p5",
  TERMS_S3_P6: "terms_s3_p6",
  TERMS_S4_TITLE: "terms_s4_title",
  TERMS_S4_P1: "terms_s4_p1",
  TERMS_S4_P2: "terms_s4_p2",
  TERMS_S4_P3: "terms_s4_p3",
  TERMS_S4_P4: "terms_s4_p4",
  TERMS_S4_P5: "terms_s4_p5",
  TERMS_S5_TITLE: "terms_s5_title",
  TERMS_S5_P1: "terms_s5_p1",
  TERMS_S5_P2: "terms_s5_p2",
  TERMS_S5_P3: "terms_s5_p3",
  TERMS_S5_P4: "terms_s5_p4",
  TERMS_S5_P5: "terms_s5_p5",
  TERMS_S6_TITLE: "terms_s6_title",
  TERMS_S6_P1: "terms_s6_p1",
  TERMS_S6_P2: "terms_s6_p2",
  TERMS_S6_P3: "terms_s6_p3",
  TERMS_S6_P4: "terms_s6_p4",
  TERMS_S6_P5: "terms_s6_p5",
  TERMS_S7_TITLE: "terms_s7_title",
  TERMS_S7_P1: "terms_s7_p1",
  TERMS_S7_P2: "terms_s7_p2",
  TERMS_S7_P3: "terms_s7_p3",
  TERMS_S7_P4: "terms_s7_p4",
  TERMS_S7_P5: "terms_s7_p5",
  TERMS_S8_TITLE: "terms_s8_title",
  TERMS_S8_P1: "terms_s8_p1",
  TERMS_S8_P2: "terms_s8_p2",
  TERMS_S8_P3: "terms_s8_p3",
  TERMS_S8_P4: "terms_s8_p4",
  TERMS_S8_P5: "terms_s8_p5",
  TERMS_S9_TITLE: "terms_s9_title",
  TERMS_S9_P1: "terms_s9_p1",
  TERMS_S9_LI1: "terms_s9_li1",
  TERMS_S9_LI2: "terms_s9_li2",
  TERMS_S9_LI3: "terms_s9_li3",
  TERMS_S9_LI4: "terms_s9_li4",
  TERMS_S9_LI5: "terms_s9_li5",
  TERMS_S9_P2: "terms_s9_p2",
  TERMS_S10_TITLE: "terms_s10_title",
  TERMS_S10_P1: "terms_s10_p1",
  TERMS_S10_P2: "terms_s10_p2",
  TERMS_S10_P3: "terms_s10_p3",
  TERMS_S10_P4: "terms_s10_p4",
  TERMS_S10_P5: "terms_s10_p5",
  TERMS_S11_TITLE: "terms_s11_title",
  TERMS_S11_P1: "terms_s11_p1",
  TERMS_S11_P2: "terms_s11_p2",
  TERMS_S12_TITLE: "terms_s12_title",
  TERMS_S12_P1: "terms_s12_p1",
  TERMS_S12_P2: "terms_s12_p2",
  TERMS_S13_TITLE: "terms_s13_title",
  TERMS_S13_P1: "terms_s13_p1",
  TERMS_S13_P2: "terms_s13_p2",
  TERMS_S13_P3: "terms_s13_p3",
  TERMS_S14_TITLE: "terms_s14_title",
  TERMS_S14_P1: "terms_s14_p1",
  TERMS_S14_P2: "terms_s14_p2",
  TERMS_LINK_ANPC: "terms_link_anpc",
  TERMS_LINK_SAL: "terms_link_sal",
  TERMS_CONTACT_COMPANY: "terms_contact_company",
  TERMS_CONTACT_CUI: "terms_contact_cui",
  TERMS_CONTACT_REG: "terms_contact_reg",
  TERMS_CONTACT_ADDRESS: "terms_contact_address",
  TERMS_CONTACT_EMAIL: "terms_contact_email",
  CLINIC_ADMIN_TAB_REMINDERS: "clinic_admin_tab_reminders",
  REMINDER_SETTINGS_TITLE: "reminder_settings_title",
  REMINDER_SETTINGS_DESCRIPTION: "reminder_settings_description",
  REMINDER_SETTINGS_ENABLED_LABEL: "reminder_settings_enabled_label",
  REMINDER_SETTINGS_SEND_TIME_LABEL: "reminder_settings_send_time_label",
  REMINDER_SETTINGS_SEND_TIME_HELPER: "reminder_settings_send_time_helper",
  REMINDER_SETTINGS_CHANNELS_LABEL: "reminder_settings_channels_label",
  REMINDER_SETTINGS_CHANNEL_EMAIL: "reminder_settings_channel_email",
  REMINDER_SETTINGS_CHANNEL_SMS: "reminder_settings_channel_sms",
  REMINDER_SETTINGS_CHANNEL_WHATSAPP: "reminder_settings_channel_whatsapp",
  REMINDER_SETTINGS_CHANNEL_UNAVAILABLE:
    "reminder_settings_channel_unavailable",
  REMINDER_SETTINGS_SAVE: "reminder_settings_save",
  REMINDER_SETTINGS_SAVE_SUCCESS: "reminder_settings_save_success",
  REMINDER_SETTINGS_SAVE_ERROR: "reminder_settings_save_error",
  REMINDER_SETTINGS_SEND_TIME_INVALID: "reminder_settings_send_time_invalid",
  REMINDER_SETTINGS_CHANNEL_REQUIRED: "reminder_settings_channel_required",
  FORM_BLOCKED_SAVE: "form_blocked_save",
  CLINIC_ADMIN_TAB_INVOICING: "clinic_admin_tab_invoicing",
  INVOICING_SETTINGS_TITLE: "invoicing_settings_title",
  INVOICING_SETTINGS_DESCRIPTION: "invoicing_settings_description",
  INVOICING_SETTINGS_PROVIDER_LABEL: "invoicing_settings_provider_label",
  INVOICING_SETTINGS_PROVIDER_NONE: "invoicing_settings_provider_none",
  INVOICING_SETTINGS_ENABLED_LABEL: "invoicing_settings_enabled_label",
  INVOICING_SETTINGS_ENABLED_HELPER: "invoicing_settings_enabled_helper",
  INVOICING_SETTINGS_CREDENTIALS_TITLE: "invoicing_settings_credentials_title",
  INVOICING_SETTINGS_CREDENTIALS_DESCRIPTION:
    "invoicing_settings_credentials_description",
  INVOICING_SETTINGS_API_USER_LABEL: "invoicing_settings_api_user_label",
  INVOICING_SETTINGS_API_SECRET_LABEL: "invoicing_settings_api_secret_label",
  INVOICING_SETTINGS_API_SECRET_PLACEHOLDER:
    "invoicing_settings_api_secret_placeholder",
  INVOICING_SETTINGS_API_SECRET_STORED: "invoicing_settings_api_secret_stored",
  INVOICING_SETTINGS_API_SECRET_HELPER: "invoicing_settings_api_secret_helper",
  INVOICING_SETTINGS_TEST: "invoicing_settings_test",
  INVOICING_SETTINGS_TEST_SUCCESS: "invoicing_settings_test_success",
  INVOICING_SETTINGS_TEST_ERROR: "invoicing_settings_test_error",
  INVOICING_SETTINGS_COMPANY_TITLE: "invoicing_settings_company_title",
  INVOICING_SETTINGS_COMPANY_DESCRIPTION:
    "invoicing_settings_company_description",
  INVOICING_SETTINGS_COMPANY_CIF_LABEL: "invoicing_settings_company_cif_label",
  INVOICING_SETTINGS_SERIES_LABEL: "invoicing_settings_series_label",
  INVOICING_SETTINGS_SERIES_HELPER: "invoicing_settings_series_helper",
  INVOICING_SETTINGS_DOCUMENT_TITLE: "invoicing_settings_document_title",
  INVOICING_SETTINGS_VAT_NAME_LABEL: "invoicing_settings_vat_name_label",
  INVOICING_SETTINGS_VAT_PERCENTAGE_LABEL:
    "invoicing_settings_vat_percentage_label",
  INVOICING_SETTINGS_PRICES_INCLUDE_VAT_LABEL:
    "invoicing_settings_prices_include_vat_label",
  INVOICING_SETTINGS_PRICES_INCLUDE_VAT_HELPER:
    "invoicing_settings_prices_include_vat_helper",
  INVOICING_SETTINGS_MEASURING_UNIT_LABEL:
    "invoicing_settings_measuring_unit_label",
  INVOICING_SETTINGS_PRODUCT_TYPE_LABEL:
    "invoicing_settings_product_type_label",
  INVOICING_SETTINGS_LANGUAGE_LABEL: "invoicing_settings_language_label",
  INVOICING_SETTINGS_CURRENCY_LABEL: "invoicing_settings_currency_label",
  INVOICING_SETTINGS_PAYMENT_TITLE: "invoicing_settings_payment_title",
  INVOICING_SETTINGS_PAYMENT_DESCRIPTION:
    "invoicing_settings_payment_description",
  INVOICING_SETTINGS_COLLECT_TYPE_LABEL:
    "invoicing_settings_collect_type_label",
  INVOICING_SETTINGS_COLLECT_SERIES_LABEL:
    "invoicing_settings_collect_series_label",
  INVOICING_SETTINGS_COLLECT_SERIES_HELPER:
    "invoicing_settings_collect_series_helper",
  INVOICING_SETTINGS_SEND_EMAIL_LABEL: "invoicing_settings_send_email_label",
  INVOICING_SETTINGS_SEND_EMAIL_HELPER: "invoicing_settings_send_email_helper",
  INVOICING_SETTINGS_SAVE: "invoicing_settings_save",
  INVOICING_SETTINGS_SAVE_SUCCESS: "invoicing_settings_save_success",
  INVOICING_SETTINGS_SAVE_ERROR: "invoicing_settings_save_error",
  INVOICING_SETTINGS_PROVIDER_REQUIRED: "invoicing_settings_provider_required",
  INVOICING_SETTINGS_API_USER_REQUIRED: "invoicing_settings_api_user_required",
  INVOICING_SETTINGS_API_SECRET_REQUIRED:
    "invoicing_settings_api_secret_required",
  INVOICING_SETTINGS_COMPANY_CIF_REQUIRED:
    "invoicing_settings_company_cif_required",
  INVOICING_SETTINGS_SERIES_REQUIRED: "invoicing_settings_series_required",
  INVOICING_SETTINGS_COLLECT_SERIES_REQUIRED:
    "invoicing_settings_collect_series_required",
  INVOICING_SETTINGS_VAT_INVALID: "invoicing_settings_vat_invalid",
  EMIT_INVOICE_ACTION: "emit_invoice_action",
  EMIT_INVOICE_TITLE: "emit_invoice_title",
  EMIT_INVOICE_PURCHASE_TITLE: "emit_invoice_purchase_title",
  EMIT_INVOICE_SOLD_ON: "emit_invoice_sold_on",
  EMIT_INVOICE_CLIENT_TITLE: "emit_invoice_client_title",
  EMIT_INVOICE_CLIENT_DESCRIPTION: "emit_invoice_client_description",
  EMIT_INVOICE_CLIENT_NAME_LABEL: "emit_invoice_client_name_label",
  EMIT_INVOICE_CLIENT_NAME_REQUIRED: "emit_invoice_client_name_required",
  EMIT_INVOICE_CLIENT_CIF_LABEL: "emit_invoice_client_cif_label",
  EMIT_INVOICE_CLIENT_ADDRESS_LABEL: "emit_invoice_client_address_label",
  EMIT_INVOICE_CLIENT_CITY_LABEL: "emit_invoice_client_city_label",
  EMIT_INVOICE_CLIENT_STATE_LABEL: "emit_invoice_client_state_label",
  EMIT_INVOICE_CLIENT_EMAIL_LABEL: "emit_invoice_client_email_label",
  EMIT_INVOICE_RECEIPT_TITLE: "emit_invoice_receipt_title",
  EMIT_INVOICE_RECEIPT_DESCRIPTION: "emit_invoice_receipt_description",
  EMIT_INVOICE_RECEIPT_NUMBER_LABEL: "emit_invoice_receipt_number_label",
  EMIT_INVOICE_RECEIPT_DATE_LABEL: "emit_invoice_receipt_date_label",
  EMIT_INVOICE_RECEIPT_AMOUNT_LABEL: "emit_invoice_receipt_amount_label",
  EMIT_INVOICE_RECEIPT_NUMBER_REQUIRED: "emit_invoice_receipt_number_required",
  EMIT_INVOICE_RECEIPT_DATE_REQUIRED: "emit_invoice_receipt_date_required",
  EMIT_INVOICE_RECEIPT_AMOUNT_REQUIRED: "emit_invoice_receipt_amount_required",
  EMIT_INVOICE_RECEIPT_PHOTO: "emit_invoice_receipt_photo",
  EMIT_INVOICE_RECEIPT_PHOTO_RETAKE: "emit_invoice_receipt_photo_retake",
  EMIT_INVOICE_RECEIPT_PHOTO_REQUIRED: "emit_invoice_receipt_photo_required",
  EMIT_INVOICE_RECEIPT_PHOTO_ALT: "emit_invoice_receipt_photo_alt",
  EMIT_INVOICE_SUBMIT: "emit_invoice_submit",
  EMIT_INVOICE_CANCEL: "emit_invoice_cancel",
  EMIT_INVOICE_SUCCESS: "emit_invoice_success",
  EMIT_INVOICE_ERROR: "emit_invoice_error",
  INVOICE_STATUS_ISSUED: "invoice_status_issued",
  INVOICE_STATUS_PENDING: "invoice_status_pending",
  INVOICE_STATUS_FAILED: "invoice_status_failed",
  INVOICE_STATUS_CANCELLED: "invoice_status_cancelled",
  INVOICE_WINDOW_EXPIRED: "invoice_window_expired",
  INVOICE_VIEW_DOCUMENT: "invoice_view_document",
  INVOICE_VIEW_RECEIPT: "invoice_view_receipt",
  INVOICE_RECEIPT_ERROR: "invoice_receipt_error",
  INVOICE_RETRY: "invoice_retry",
  INVOICE_RETRY_SUCCESS: "invoice_retry_success",
  INVOICE_RETRY_ERROR: "invoice_retry_error",
  INVOICE_CANCEL: "invoice_cancel",
  INVOICE_CANCEL_CONFIRM_TITLE: "invoice_cancel_confirm_title",
  INVOICE_CANCEL_CONFIRM_MESSAGE: "invoice_cancel_confirm_message",
  INVOICE_CANCEL_SUCCESS: "invoice_cancel_success",
  INVOICE_CANCEL_ERROR: "invoice_cancel_error",
  CLINIC_ADMIN_TAB_WORKING_HOURS: "clinic_admin_tab_working_hours",
  WORKING_HOURS_TITLE: "working_hours_title",
  WORKING_HOURS_DESCRIPTION: "working_hours_description",
  WORKING_HOURS_OPEN_LABEL: "working_hours_open_label",
  WORKING_HOURS_CLOSED_LABEL: "working_hours_closed_label",
  WORKING_HOURS_DAY_TOGGLE_LABEL: "working_hours_day_toggle_label",
  WORKING_HOURS_SAVE: "working_hours_save",
  WORKING_HOURS_SAVE_SUCCESS: "working_hours_save_success",
  WORKING_HOURS_SAVE_ERROR: "working_hours_save_error",
  WORKING_HOURS_LOAD_ERROR: "working_hours_load_error",
  WEEKDAY_MONDAY: "weekday_monday",
  WEEKDAY_TUESDAY: "weekday_tuesday",
  WEEKDAY_WEDNESDAY: "weekday_wednesday",
  WEEKDAY_THURSDAY: "weekday_thursday",
  WEEKDAY_FRIDAY: "weekday_friday",
  WEEKDAY_SATURDAY: "weekday_saturday",
  WEEKDAY_SUNDAY: "weekday_sunday",
  BOOKING_CLINIC_CLOSED_THAT_DAY: "booking_clinic_closed_that_day",
  CLINIC_ADMIN_TAB_HOME: "clinic_admin_tab_home",
  HOME_SETTINGS_HERO_TITLE: "home_settings_hero_title",
  HOME_SETTINGS_HERO_HINT: "home_settings_hero_hint",
  HOME_SETTINGS_FEATURES_TITLE: "home_settings_features_title",
  HOME_SETTINGS_FEATURES_HINT: "home_settings_features_hint",
  HOME_SETTINGS_CTA_TITLE: "home_settings_cta_title",
  HOME_SETTINGS_CTA_HINT: "home_settings_cta_hint",
  HOME_FIELD_HIDE_HINT: "home_field_hide_hint",
  HOME_FIELD_EN_HINT: "home_field_en_hint",
  HOME_HEADLINE_REQUIRED: "home_headline_required",
  HOME_FIELD_EYEBROW_RO: "home_field_eyebrow_ro",
  HOME_FIELD_EYEBROW_EN: "home_field_eyebrow_en",
  HOME_FIELD_HEADLINE1_RO: "home_field_headline1_ro",
  HOME_FIELD_HEADLINE1_EN: "home_field_headline1_en",
  HOME_FIELD_HEADLINE2_RO: "home_field_headline2_ro",
  HOME_FIELD_HEADLINE2_EN: "home_field_headline2_en",
  HOME_FIELD_SUBTITLE_RO: "home_field_subtitle_ro",
  HOME_FIELD_SUBTITLE_EN: "home_field_subtitle_en",
  HOME_FIELD_SECTION_TITLE_RO: "home_field_section_title_ro",
  HOME_FIELD_SECTION_TITLE_EN: "home_field_section_title_en",
  HOME_FIELD_SECTION_SUBTITLE_RO: "home_field_section_subtitle_ro",
  HOME_FIELD_SECTION_SUBTITLE_EN: "home_field_section_subtitle_en",
  HOME_FIELD_CTA_TITLE_RO: "home_field_cta_title_ro",
  HOME_FIELD_CTA_TITLE_EN: "home_field_cta_title_en",
  HOME_FIELD_CTA_SUBTITLE_RO: "home_field_cta_subtitle_ro",
  HOME_FIELD_CTA_SUBTITLE_EN: "home_field_cta_subtitle_en",
  HOME_FIELD_CARD_ICON: "home_field_card_icon",
  HOME_FIELD_CARD_TITLE_RO: "home_field_card_title_ro",
  HOME_FIELD_CARD_TITLE_EN: "home_field_card_title_en",
  HOME_FIELD_CARD_BODY_RO: "home_field_card_body_ro",
  HOME_FIELD_CARD_BODY_EN: "home_field_card_body_en",
  HOME_CARD_NUMBER: "home_card_number",
  HOME_CARD_ADD: "home_card_add",
  HOME_CARD_REMOVE: "home_card_remove",
  HOME_CARD_MOVE_UP: "home_card_move_up",
  HOME_CARD_MOVE_DOWN: "home_card_move_down",
  HOME_CARDS_EMPTY_HINT: "home_cards_empty_hint",
  HOME_CARD_TITLE_REQUIRED: "home_card_title_required",
  HOME_CARD_BODY_REQUIRED: "home_card_body_required",
  HOME_HERO_IMAGE_HINT: "home_hero_image_hint",
  HOME_HERO_IMAGE_NONE: "home_hero_image_none",
  HOME_HERO_IMAGE_UPLOAD: "home_hero_image_upload",
  HOME_HERO_IMAGE_REPLACE: "home_hero_image_replace",
  HOME_HERO_IMAGE_REMOVE: "home_hero_image_remove",
  HOME_HERO_UPLOAD_SUCCESS: "home_hero_upload_success",
  HOME_HERO_UPLOAD_ERROR: "home_hero_upload_error",
  HOME_HERO_REMOVE_SUCCESS: "home_hero_remove_success",
  HOME_HERO_REMOVE_ERROR: "home_hero_remove_error",
  HOME_HERO_CROP_TITLE: "home_hero_crop_title",
  HOME_HERO_CROP_SAVE: "home_hero_crop_save",
  HOME_HERO_CROP_PREVIEW_CROP: "home_hero_crop_preview_crop",
  HOME_HERO_CROP_PREVIEW_BAND: "home_hero_crop_preview_band",
  HOME_HERO_CROP_SAMPLE_HEADLINE: "home_hero_crop_sample_headline",
  HOME_SETTINGS_SAVE: "home_settings_save",
  HOME_SETTINGS_SAVE_SUCCESS: "home_settings_save_success",
  HOME_SETTINGS_SAVE_ERROR: "home_settings_save_error",
  HOME_SETTINGS_BLOCKED_SAVE: "home_settings_blocked_save",
  HOME_PREVIEW_TITLE: "home_preview_title",
  HOME_PREVIEW_HINT: "home_preview_hint",
  MY_SCHEDULE_NAV: "my_schedule_nav",
  MY_SCHEDULE_TITLE: "my_schedule_title",
  MY_SCHEDULE_DESCRIPTION: "my_schedule_description",
  MY_SCHEDULE_USING_CLINIC_HOURS: "my_schedule_using_clinic_hours",
  MY_SCHEDULE_CUSTOM_HOURS: "my_schedule_custom_hours",
  MY_SCHEDULE_SAVE: "my_schedule_save",
  MY_SCHEDULE_SAVE_SUCCESS: "my_schedule_save_success",
  MY_SCHEDULE_SAVE_ERROR: "my_schedule_save_error",
  MY_SCHEDULE_LOAD_ERROR: "my_schedule_load_error",
  MY_SCHEDULE_RESET: "my_schedule_reset",
  MY_SCHEDULE_RESET_SUCCESS: "my_schedule_reset_success",
  MY_SCHEDULE_CLINIC_CLOSED_HINT: "my_schedule_clinic_closed_hint",
  MY_SCHEDULE_CLINIC_CLOSED_ERROR: "my_schedule_clinic_closed_error",
  MY_SCHEDULE_OUTSIDE_CLINIC_ERROR: "my_schedule_outside_clinic_error",
  WORKING_HOURS_THERAPISTS_NARROWED: "working_hours_therapists_narrowed",
  BOOK_APPOINTMENT_DAY_UNAVAILABLE: "book_appointment_day_unavailable",
  THERAPIST_SCHEDULE_ACTION: "therapist_schedule_action",
  THERAPIST_SCHEDULE_TITLE: "therapist_schedule_title",
  THERAPIST_SCHEDULE_CLINIC_DEFAULT: "therapist_schedule_clinic_default",
  THERAPIST_SCHEDULE_CUSTOM: "therapist_schedule_custom",
  THERAPIST_SCHEDULE_DAY_OFF: "therapist_schedule_day_off",
  THERAPIST_SCHEDULE_LOAD_ERROR: "therapist_schedule_load_error",
  MY_SCHEDULE_AVAILABLE_LABEL: "my_schedule_available_label",
  MY_SCHEDULE_UNAVAILABLE_LABEL: "my_schedule_unavailable_label",
  MY_SCHEDULE_DAY_TOGGLE_LABEL: "my_schedule_day_toggle_label",
  MY_SCHEDULE_START_LABEL: "my_schedule_start_label",
  MY_SCHEDULE_END_LABEL: "my_schedule_end_label",
  PROFILE_PICTURE_TITLE: "profile_picture_title",
  PROFILE_PICTURE_UPLOAD: "profile_picture_upload",
  PROFILE_PICTURE_CHANGE: "profile_picture_change",
  PROFILE_PICTURE_REMOVE: "profile_picture_remove",
  PROFILE_PICTURE_EDIT_ERROR: "profile_picture_edit_error",
  PROFILE_PICTURE_CROP_TITLE: "profile_picture_crop_title",
  PROFILE_PICTURE_CROP_HINT: "profile_picture_crop_hint",
  PROFILE_PICTURE_CROP_PREVIEW_CROP: "profile_picture_crop_preview_crop",
  PROFILE_PICTURE_CROP_PREVIEW_HEADER: "profile_picture_crop_preview_header",
  PROFILE_PICTURE_CROP_SAVE: "profile_picture_crop_save",
  PROFILE_PICTURE_SUCCESS: "profile_picture_success",
  PROFILE_PICTURE_REMOVED: "profile_picture_removed",
  PROFILE_PICTURE_ERROR: "profile_picture_error",
  PROFILE_PICTURE_ALT: "profile_picture_alt",
  LANGUAGE_SELECT_LABEL: "language_select_label",
  LANGUAGE_RO: "language_ro",
  LANGUAGE_EN: "language_en",
  BRANDING_DEFAULT_LANGUAGE_TITLE: "branding_default_language_title",
  BRANDING_DEFAULT_LANGUAGE_LABEL: "branding_default_language_label",
  BRANDING_DEFAULT_LANGUAGE_NONE: "branding_default_language_none",
  BRANDING_DEFAULT_LANGUAGE_HINT: "branding_default_language_hint",
  BRANDING_DEFAULT_LANGUAGE_INVALID: "branding_default_language_invalid",
  DASHBOARD_TABLE_THERAPIST_SHARE: "dashboard_table_therapist_share",
  THERAPIST_INCOME_SHARE_CHIP: "therapist_income_share_chip",
  REVENUE_SHARE_COLUMN: "revenue_share_column",
  REVENUE_SHARE_PERCENT_VALUE: "revenue_share_percent_value",
  REVENUE_SHARE_PERCENT_REQUIRED: "revenue_share_percent_required",
  REVENUE_SHARE_PERCENT_INVALID: "revenue_share_percent_invalid",
  REVENUE_SHARE_SUCCESS: "revenue_share_success",
  REVENUE_SHARE_ERROR: "revenue_share_error",
  REVENUE_SHARE_FOOTNOTE: "revenue_share_footnote",
  REVENUE_SHARE_CLEAR_ACTION: "revenue_share_clear_action",
  REVENUE_SHARE_CLEARED_SUCCESS: "revenue_share_cleared_success",
  REVENUE_SHARE_NONE: "revenue_share_none",
  REVENUE_SHARE_TITLE: "revenue_share_title",
  REVENUE_SHARE_EDIT_LABEL: "revenue_share_edit_label",
  REVENUE_SHARE_PERCENT_LABEL: "revenue_share_percent_label",
  REVENUE_SHARE_SCHEDULED: "revenue_share_scheduled",
  REVENUE_SHARE_EXPLAIN_NEW: "revenue_share_explain_new",
  REVENUE_SHARE_EXPLAIN_REPLACING: "revenue_share_explain_replacing",
  REVENUE_SHARE_DEFAULT_LABEL: "revenue_share_default_label",
  REVENUE_SHARE_DISCIPLINES_TITLE: "revenue_share_disciplines_title",
  REVENUE_SHARE_DISCIPLINES_HINT: "revenue_share_disciplines_hint",
  REVENUE_SHARE_OVERRIDES_CHIP: "revenue_share_overrides_chip",
  REVENUE_SHARE_LOAD_ERROR: "revenue_share_load_error",
  THERAPIST_INCOME_SHARE_RATE: "therapist_income_share_rate",
  PUBLIC_BOOKING_TITLE: "public_booking_title",
  PUBLIC_BOOKING_SUBTITLE: "public_booking_subtitle",
  PUBLIC_BOOKING_NO_SERVICES: "public_booking_no_services",
  PUBLIC_BOOKING_STEP_DETAILS: "public_booking_step_details",
  PUBLIC_BOOKING_NEW_TAB: "public_booking_new_tab",
  PUBLIC_BOOKING_EXISTING_TAB: "public_booking_existing_tab",
  PUBLIC_BOOKING_NOTE_LABEL: "public_booking_note_label",
  PUBLIC_BOOKING_NOTE_HINT: "public_booking_note_hint",
  PUBLIC_BOOKING_HONEYPOT_LABEL: "public_booking_honeypot_label",
  PUBLIC_BOOKING_GDPR_CONSENT_LABEL: "public_booking_gdpr_consent_label",
  PUBLIC_BOOKING_NOT_RESERVED_HINT: "public_booking_not_reserved_hint",
  PUBLIC_BOOKING_SUBMIT: "public_booking_submit",
  PUBLIC_BOOKING_SUBMIT_FAILED: "public_booking_submit_failed",
  PUBLIC_BOOKING_CHECK_EMAIL_TITLE: "public_booking_check_email_title",
  PUBLIC_BOOKING_CHECK_EMAIL_BODY: "public_booking_check_email_body",
  PUBLIC_BOOKING_CHECK_EMAIL_RESEND: "public_booking_check_email_resend",
  PUBLIC_BOOKING_CHECK_EMAIL_RESENT: "public_booking_check_email_resent",
  PUBLIC_BOOKING_CHECK_EMAIL_CHANGE: "public_booking_check_email_change",
  PUBLIC_BOOKING_LOGIN_HINT: "public_booking_login_hint",
  PUBLIC_BOOKING_LOGIN_FAILED_HINT: "public_booking_login_failed_hint",
  PUBLIC_BOOKING_VERIFY_TITLE: "public_booking_verify_title",
  PUBLIC_BOOKING_VERIFY_SUMMARY: "public_booking_verify_summary",
  PUBLIC_BOOKING_VERIFY_CHOOSE_PASSWORD:
    "public_booking_verify_choose_password",
  PUBLIC_BOOKING_VERIFY_ENTER_PASSWORD: "public_booking_verify_enter_password",
  PUBLIC_BOOKING_VERIFY_CONFIRM: "public_booking_verify_confirm",
  PUBLIC_BOOKING_VERIFY_INVALID: "public_booking_verify_invalid",
  PUBLIC_BOOKING_VERIFY_EXPIRED: "public_booking_verify_expired",
  PUBLIC_BOOKING_VERIFY_USED: "public_booking_verify_used",
  PUBLIC_BOOKING_VERIFY_NOT_ELIGIBLE: "public_booking_verify_not_eligible",
  PUBLIC_BOOKING_VERIFY_FAILED: "public_booking_verify_failed",
  PUBLIC_BOOKING_SLOT_TAKEN: "public_booking_slot_taken",
  PUBLIC_BOOKING_CHOOSE_AGAIN: "public_booking_choose_again",
  CLINIC_ADMIN_TAB_ROOMS: "clinic_admin_tab_rooms",
  ROOMS_TITLE: "rooms_title",
  ROOMS_DESCRIPTION: "rooms_description",
  ROOMS_ADD_ACTION: "rooms_add_action",
  ROOMS_EMPTY: "rooms_empty",
  ROOMS_LOAD_ERROR: "rooms_load_error",
  ROOMS_CAPACITY_LABEL: "rooms_capacity_label",
  ROOMS_CAPACITY_HELPER: "rooms_capacity_helper",
  ROOMS_CAPACITY_INVALID: "rooms_capacity_invalid",
  ROOMS_SERVICES_LABEL: "rooms_services_label",
  ROOMS_SERVICES_NONE: "rooms_services_none",
  ROOMS_SERVICES_DESCRIPTION: "rooms_services_description",
  ROOMS_SERVICE_TAKEN: "rooms_service_taken",
  ROOMS_CREATE_TITLE: "rooms_create_title",
  ROOMS_EDIT_TITLE: "rooms_edit_title",
  ROOMS_NAME_LABEL: "rooms_name_label",
  ROOMS_NAME_REQUIRED: "rooms_name_required",
  ROOMS_SAVE_ERROR: "rooms_save_error",
  ROOMS_CREATED_SUCCESS: "rooms_created_success",
  ROOMS_UPDATED_SUCCESS: "rooms_updated_success",
  ROOMS_DELETE_ACTION: "rooms_delete_action",
  ROOMS_DELETE_TITLE: "rooms_delete_title",
  ROOMS_DELETE_DESCRIPTION: "rooms_delete_description",
  ROOMS_DELETED_SUCCESS: "rooms_deleted_success",
  ROOMS_DELETE_ERROR: "rooms_delete_error",
};

export default ResourcesIds;
